/** ***** Main App ******* */
const AsgApp = (function () {
    let coreFrameworkSettings;
    let lng;
    let languageIso2;
    let wpmlLanguage;
    let defaultLng;
    let currency;
    let country;
    let frameworkUri;
    let appEnv;
    let pamEnv;
    let cdnHost;
    let fncHost;
    let solarHost;
    let gatewayHost;
    let pamAsgWebApiHost;
    let ajaxUri;
    let themeUri;
    let bannersWeb;
    let unsegmentedBanners = [];
    let universalImagesUri;
    let generalImagesUri;
    let crmImagesUri;
    let gameThumbImagesUri;
    let sport;
    let virtualSport;
    let sportLaunchingMode;
    let sportSlug;
    let sportWidgetSlug;
    let doubleGameSize;
    let forbiddenSportCountriesArr;
    let asgData;
    let isPhoneGap;
    let currentGameId;
    let currentGame;
    let isNgReady;
    let balanceInterval = null;
    let CurrencySign;
    let chatAfterLogin = false;
    const dictionaryRequest = $.Deferred();
    const partialsRequest = $.Deferred();
    let preloadGamesArr;
    let onLoginCallbackFunc;
    const eventTrackTmpFlag = true;
    let isOnSessionStatusUpdateSettled = false;
    let isJustLoggedInSettled;
    let isJustLoggedOutSettled;
    let isLoggedInByCookie;
    const bonusMessageTimeout = 4000;
    let isNativeApp;
    let isNativeSsoApp;
    let isNativeFooterMenuVisible;
    let isNativeSocialMediaVisible;
    let isNativeCopyRightVisible;
    let mobileOsType;
    const verticals = {};
    let customTermsLink = '';
    let iSoftBetData;

    // Hardcode country codes, where demo games are forbidden.
    const noDemoGamesCountries = ['uk', 'gb', 'de', 'nl'];
    const sessionClockBarCountries = ['nl'];

    // Hardcode possible languages uri codes.
    const lngPossibleArr = ['uk', 'no', 'nl', 'it', 'fr', 'fi', 'es', 'en', 'dk', 'de', 'be', 'au', 'ja', 'br'];
    // Hardcode possible region URI codes.
    const regPossibleArr = ['on'];

    // ASG Pay&Play flag status. do not confuse with NG's flag:
    // AsgApp.getPayNPlayData().isPayNPlayIntegrationEnabled
    let PayNPlay;
    let currentPageTemplate;
    let exponeaToken = '';
    let useEngageDomainPerBrand = false;
    let exponeaHost = null;
    /**
     * WalkThrough parameters
     * @type {boolean}
     */
    let walkThroughStatus;
    let needWalkThroughSkipStatus = false;

    // count of evolution games item show
    const countOfEvolutionGamesItem = 6;

    // unsubscribe function for verification strip updates
    let verificationUnsubscribeFn;

    const statusBarEvents = 'LoggedIn LoggedOut fw_balanceUpdated endInGame startInGame';

    let leftMenuData = {};

    const cookieNames = Object.freeze({
        GAME_NOT_AVAILABLE_NOTIFICATION: 'asgGameNotAvailableNotification',
        OPEN_POST_LOGIN_GAME_PAGE: 'asgOpenPostLoginGamePage',
        GAME_VERTICAL_ID: 'GameVerticalID',
        CURRENT_VERTICAL_ID: 'currentVerticalId', // current vertical object
        CURRENT_VERTICAL_TYPE: 'currentVerticalType',
    });

    let backendVerticalsMenu;

    const verticalTypesEnum = Object.freeze({
        CASINO: 'casino',
        LIVE_CASINO: 'liveCasino',
        SPORT: 'sport',
        RECOMMENDATIONS: 'recommendations',
    });

    const verticalActionTypesEnum = Object.freeze({
        CORE_CATEGORY: 'asgCoreCategory',
        CORE_ACTION: 'asgCoreAction',
        SPORT: 'sport',
        LOAD_GAME: 'loadGame',
        OPEN_LINK: 'openLink',
        MOBILE_APP_CATEGORY: 'mobileAppCategory',
        PLATFORM_CATEGORIES: 'virtualPlatformCategories',
        FEATURED_GAMES: 'featuredGamesCategory',
        BUYWIN_CATEGORY: 'buywinGamesCategory',
        JACKPOT_CATEGORY: 'asgJackpotCategory',
        JACKPOT_VIRTUAL_CATEGORIES: 'virtualJackpotCategories',
        RECOMMENDATIONS_CATEGORY: 'recommendedGamesCategory',
        FAVORITES_CATEGORY: 'favoriteGamesCategory',
    });

    const solarVerticalIdsEnum = Object.freeze({
        1: 'casino',
        2: 'sport',
        3: 'bingo',
        4: 'liveCasino',
        5: 'scratchcards',
    });

    const casinoLikeVerticals = [verticalTypesEnum.CASINO, verticalTypesEnum.LIVE_CASINO];

    let placeholderBannerData = null;
    let showBingoBannerData = null;
    let templateDirectoryUri = null;
    let sportLoaderIcons = null;
    let sportMainBannerData = null;
    let logoImageData = null;
    let languageSwitcherData = null;
    let cmsGamesCollection = null;
    let neoCmsIntegration = null;

    const init = function (appConfig, data) {
        setFrameworkPreferences(appConfig, data);

        AsgFW.initAspireEngage(getExponeaUrl(), getExponeaToken(), 'web.com.s2c');

        AsgFW.init(coreFrameworkSettings);

        setConfigToStore();
        setIsSearchEnabledToStore();

        setLangCookie();
        setLoggedInByCookieHandler();

        $(document).on('dictionaryReady', function () {
            subscribeForBannersUpdates();
            Games.loadPartials();
            preloadGames();
            setActionEventsAsync();
            setOnReadyEvent();
            setMissingFuncs();
            prepareVerticals();
            Games.init();
            if (isNeoCmsIntegrationEnabled()) {
                Games.processCmsGames(cmsGamesCollection);
            }
            fixStandaloneIOS();
            SolarAPI.init({ solarKey: appConfig.solarKey });
            setVerticalsEventHandlers();
            AsgUI.cleanInfoPage();
            getPrioritizedGames();
            renderLtPromotions();
            renderEmbeddedGame();
        });
        InGame.setNewGamePagePreferences();
    };

    const preloadGames = function () {
        setPreloadData();
        if (!preloadGamesArr || preloadGamesArr.length === 0) {
            return;
        }

        preloadGamesArr = AsgUI.populatePreloadImages(preloadGamesArr);
        Games.setPreloadGames(preloadGamesArr);
    };

    const setPreloadData = function () {
        preloadGamesArr = asgData.preloadGamesArr;
    };

    const getPreloadData = function () {
        return preloadGamesArr;
    };

    const checkUserStatusCookie = function () {
        return parseInt(Cookie.read('lastTimeStatus'), 10);
    };

    const isNgFwReady = function () {
        return !!isNgReady;
    };

    const getCountry = function () {
        return country;
    };

    const isAustria = function () {
        return getCountry() === 'at';
    };

    const showChatAfterLogin = function () {
        return chatAfterLogin;
    };

    const checkingCookiePolicyExist = function () {
        if (!Cookie.read('CookiePolicy') && !AsgFW.getRbcSettings('cookieBotKeyConfig')) {
            $(document).trigger('showCookiePopup');
        }
    };

    const isHOmePage = function () {
        return window.location.pathname === '/';
    };

    const setFrameworkPreferences = function (appConfig, data) {
        asgData = data || {};
        appEnv = getAppConfigValue(appConfig, 'appEnv', null);
        pamEnv = getAppConfigValue(appConfig, 'pamEnv', null);
        cdnHost = getAppConfigValue(appConfig, 'cdnHost', null);
        fncHost = getAppConfigValue(appConfig, 'fncHost', null);
        solarHost = getAppConfigValue(appConfig, 'solarHost', null);
        gatewayHost = getAppConfigValue(appConfig, 'gatewayHost', null);
        pamAsgWebApiHost = getAppConfigValue(appConfig, 'pamAsgWebApiHost', null);

        coreFrameworkSettings = {
            appEnv,
            pamEnv,
            cdnHost,
            fncHost,
            solarHost,
            gatewayHost,
            pamAsgWebApiHost,
            BrandID: appConfig.BrandID,
            Language: appConfig.Language,
            Platform: appConfig.Platform,
            URLParams: appConfig.URLParams,
            CurrencySign: appConfig.CurrencySign,
            IsGameStandaloneMode: false,
            isShowOnlyWinnersOfThisBrand: appConfig.isShowOnlyWinnersOfThisBrand,
            balanceUpdateUkMode: appConfig.balanceUpdateUkMode,
            BrandDomain: getBrandDomain(),
            OpenPageFunc: ng_openPage,
            gameSrvEnvOverride: appConfig.gameSrvEnvOverride,
            asgSrvEnvOverride: appConfig.asgSrvEnvOverride || Tools.getEnvPrefix().slice(0, -1),
            loadSport: (typeof appConfig.loadSport !== 'undefined') ? appConfig.loadSport : true,
            platformFrameworkUrl: getAppConfigValue(appConfig, 'platformFrameworkUrl', null),
            version: getAppConfigValue(appConfig, 'version', ''),
            // Special internal 'always true' flag to indicate AsgFW,
            // that the brand is hosted by ASG.
            isAsgHosted: true,
        };

        lng = appConfig.Language;
        wpmlLanguage = appConfig.wpmlLanguage;
        languageIso2 = appConfig.languageIso2;
        defaultLng = appConfig.defaultLng;
        currency = appConfig.Currency;
        country = appConfig.Country;
        CurrencySign = appConfig.CurrencySign;
        frameworkUri = appConfig.AsgFrameworkUri;
        themeUri = appConfig.ThemeUri;
        universalImagesUri = appConfig.universalImagesUri;
        generalImagesUri = appConfig.generalImagesUri;
        crmImagesUri = appConfig.crmImagesUri;
        gameThumbImagesUri = appConfig.gameThumbImagesUri;
        customTermsLink = appConfig.customTermsLink;

        sport = getAppConfigValue(appConfig, 'sport', false);
        virtualSport = getAppConfigValue(appConfig, 'virtualSport', false);
        sportLaunchingMode = getAppConfigValue(appConfig, 'sportLaunchingMode', false);
        sportSlug = getAppConfigValue(appConfig, 'sportSlug', '');
        sportWidgetSlug = getAppConfigValue(appConfig, 'sportWidgetSlug', '');
        isPhoneGap = getAppConfigValue(appConfig, 'phonegap', false);
        doubleGameSize = getAppConfigValue(appConfig, 'double_game_size', false);
        forbiddenSportCountriesArr = getAppConfigValue(appConfig, 'forbiddenSportCountries', []);
        PayNPlay = getAppConfigValue(appConfig, 'PayNPlay', false);
        walkThroughStatus = getAppConfigValue(appConfig, 'walkThroughStatus', false);
        exponeaToken = getAppConfigValue(appConfig, 'exponeaToken', '');
        useEngageDomainPerBrand = getAppConfigValue(appConfig, 'useEngageDomainPerBrand', false);
        exponeaHost = getAppConfigValue(appConfig, 'exponeaHost', false);
        currentPageTemplate = getAppConfigValue(appConfig, 'pageTemplate', null);
        isNativeApp = getAppConfigValue(appConfig, 'isNativeApp', false);
        isNativeSsoApp = getAppConfigValue(appConfig, 'isNativeSsoApp', false);
        isNativeFooterMenuVisible = getAppConfigValue(appConfig, 'isNativeFooterMenuVisible', false);
        isNativeSocialMediaVisible = getAppConfigValue(appConfig, 'isNativeSocialMediaVisible', false);
        isNativeCopyRightVisible = getAppConfigValue(appConfig, 'isNativeCopyRightVisible', false);
        mobileOsType = getAppConfigValue(appConfig, 'mobileOsType', null);
        leftMenuData = getAppConfigValue(appConfig, 'leftMenuData', { title: '', welcomeEmojiCode: '', langs: {} });
        languageSwitcherData = getAppConfigValue(appConfig, 'languageSwitcherData', null);
        backendVerticalsMenu = getAppConfigValue(appConfig, 'verticalsMenu', null);
        placeholderBannerData = getAppConfigValue(appConfig, 'placeholderBannerData', null);
        showBingoBannerData = getAppConfigValue(appConfig, 'showBingoBannerData', null);
        templateDirectoryUri = getAppConfigValue(appConfig, 'templateDirectoryUri', null);
        sportLoaderIcons = getAppConfigValue(appConfig, 'sportLoaderIcons', null);
        sportMainBannerData = getAppConfigValue(data, 'sportMainBannerData', null);
        logoImageData = getAppConfigValue(appConfig, 'logoImageData', null);
        unsegmentedBanners = getAppConfigValue(data, 'unsegmentedBanners', []);
        ajaxUri = getAppConfigValue(data, 'ajaxUri', null);
        const hasPhonegap = getAppConfigValue(appConfig, 'phonegap', null);
        if (hasPhonegap) {
            Phonegap.init(appConfig.phonegap);
        }

        neoCmsIntegration = getAppConfigValue(appConfig, 'neoCmsIntegration', false);
        cmsGamesCollection = getAppConfigValue(appConfig, 'verticalGames', null);
    };

    const getAppConfigValue = (appConfig, value, defaultValue) => (
        Object.prototype.hasOwnProperty.call(appConfig, value)
            ? appConfig[value]
            : defaultValue
    );

    const getIsOneOfNativeApps = () => getIsNativeApp() || getIsNativeSsoApp();

    const getIsNativeApp = () => isNativeApp;

    const getIsNativeSsoApp = () => isNativeSsoApp;

    const getIsNativeFooterMenuVisible = () => isNativeFooterMenuVisible;

    const getIsNativeSocialMediaVisible = () => isNativeSocialMediaVisible;

    const getIsNativeCopyRightVisible = () => isNativeCopyRightVisible;

    /**
     * get Exponea Token from config
     */
    const getExponeaToken = () => exponeaToken;

    const getExponeaUrl = () => {
        let exponeaUrl = 'https://crm-api.aspireglobal.com';

        if (exponeaHost) {
            exponeaUrl = `https://${exponeaHost}`;
        } else if (useEngageDomainPerBrand) {
            exponeaUrl = `https://crm-api.${getBrandDomain()}`;
        }

        return exponeaUrl;
    };

    /**
     * Get WalkThrough status
     * @returns {boolean}
     */
    const getWalkThroughStatus = () => walkThroughStatus;

    /**
     * get WalkThrough status from cookie
     * @returns {boolean}
     */
    const getCookieWalkThroughStatus = () => Cookie.read('walkThroughBeenIntroduced') !== '1';

    /**
     * set WalkThrough status on cookie
     */
    const setCookieWalkThroughStatus = () => {
        Cookie.create('walkThroughBeenIntroduced', '1', '180', '/');
    };

    /**
     * return true if need open WalkThrough
     * on mobile filter: isMobile and isLoggedIn and currentGameIsNetEnt
     * and getWalkThroughStatus == true and CookieWalkThroughStatus == false
     * on Desktop filter: getWalkThroughStatus == true and CookieWalkThroughStatus == false
     * @returns {*|boolean}
     */
    const isShowWalkThrough = function () {
        // Skip if it is not an InGame mode.
        if (!InGame.isInGame()) return false;
        if (!document.querySelector('.game-improvements-component-overly')) return false;

        if (!AsgFW.isMobilePamPlatform()) {
            return getCookieWalkThroughStatus();
        }

        if (AsgFW.isMobilePamPlatform()) {
            return Player.isLoggedIn()
                && AsgFW.isDEregulation() && currentGameIsNetEnt()
                && getWalkThroughStatus() && getCookieWalkThroughStatus();
        }
    };

    /**
     * init skip parameters on WalkThrough open
     */
    const openWalkThroughSkip = function () {
        $('.game-improvements-component-overly').addClass('show-walk-through');
        $('body').addClass('walk-through-active');
        setCookieWalkThroughStatus();
        setWalkThroughSkipStatus(true);
    };

    /**
     * set WalkThrough Skip Status
     * @param status
     */
    const setWalkThroughSkipStatus = function (status) {
        needWalkThroughSkipStatus = status;
    };

    /**
     * close WalkThrough if need to close
     */
    const closeWalkThroughIfOpen = () => {
        if (needWalkThroughSkipStatus) {
            setCookieWalkThroughStatus();
            $('.game-improvements-component-overly').removeClass('show-walk-through');
            $('body').removeClass('walk-through-active');
            needWalkThroughSkipStatus = false;
        }
    };

    /**
     * return true if current game is NetEnt
     * @returns {boolean}
     */
    const currentGameIsNetEnt = () => document.body.classList.contains('start-in-game')
        && document.body.classList.contains('netent-game');

    /**
     * @return {boolean}
     */
    const isCuracaoRegulation = function () {
        return AsgFW.getRegulation().toLowerCase() === 'cw';
    };

    const getCountOfEvolutionGamesItem = function () {
        return countOfEvolutionGamesItem;
    };

    const isPayNPlayEnabled = function () {
        return PayNPlay;
    };

    const getBonusMessageTimeout = function () {
        return bonusMessageTimeout;
    };

    const isUkCountry = function () {
        return country === 'uk';
    };

    /**
     * Detects whether current player's geolocation is Germany.
     * @returns {boolean}
     */
    const isDEcountry = function () {
        return country === 'de';
    };

    /**
     * Detects whether Buy Win feature (for Germany) is active.
     * @returns {boolean}
     */
    const isGermanyBuyWinActive = function () {
        const germanyBuyWin = AsgFW.getRbcSettings('germanyBuyWin') || false;
        return germanyBuyWin && AsgFW.isDEregulation();
    };

    const getGermanyBuyWinExcludedSubProviders = function () {
        return AsgFW.getBrandInit().data.RBCSettings.buyWinExcludeSubProviders || [];
    };

    const isNoDemoGamesCountry = function () {
        const detectedCountry = AsgFW.getDetectedCountry();
        return noDemoGamesCountries.includes(detectedCountry.toLowerCase()) || Player.isLoggedIn();
    };

    /**
     * Detects if current country is needed to be session clock bar displayed.
     * @returns bool
     */
    const isSessionClockBarCountry = function () {
        const detectedCountry = AsgFW.getCurrentCountry();

        return sessionClockBarCountries.includes(detectedCountry.toLowerCase());
    };

    const isLtPromotionsEnabled = function () {
        return AsgFW.getRbcSettings('initLimitedTimePromotions');
    };

    const getLeftMenuData = () => ({
        title: leftMenuData.title,
        welcomeEmojiCode: leftMenuData.welcomeEmojiCode,
        langs: languageSwitcherData,
    });

    // Reload the site if country/regulation was changed.
    $(document).on('countryRegulationChanged', () => {
        location.reload();
    });

    // Globally add body.no-demo-class to pages according to conditions.
    $(document).on('LoggedIn LoggedOut', function () {
        if (isNoDemoGamesCountry()) {
            $('body').addClass('no-demo-games');
            $('.demoplaylink, .idemoplaylink').addClass('no-demo');
        } else {
            $('body').removeClass('no-demo-games');
            $('.demoplaylink.no-demo, .idemoplaylink.no-demo').removeClass('no-demo');
        }
    });

    const redirectPageGamesBasedList = function (gameName) {
        const gid = Games.getGameByName(gameName);
        if (gid) {
            if (Games.isPresentPageGames(gid.id)) {
                document.location.href = '/';
            }
        }
    };

    const redirectPageGameIfGameNotExist = function (gameName, withNotification = false) {
        const gid = Games.getGameByName(gameName);
        if (!gid || !AsgFW.getGameById(gid.id)) {
            if (withNotification) {
                Cookie.create(cookieNames.GAME_NOT_AVAILABLE_NOTIFICATION, true, '180', '/');
            }
            redirectToLobby();
        }
    };

    const isDoubleGameSize = function () {
        return doubleGameSize;
    };

    const getCurrencySign = function () {
        return CurrencySign;
    };

    const getForbiddenSportCountries = function () {
        return forbiddenSportCountriesArr;
    };

    const hasAustriaFlag = function () {
        return AsgFW.getRbcSettings('austriaFlag') || false;
    };

    const isSportActive = function () {
        if (sport && sportLaunchingMode) {
            return Player.isLoggedIn();
        }
        return sport;
    };

    const isVirtualSportsActive = function () {
        if (virtualSport) {
            return virtualSport;
        }
        return false;
    };

    const isSportVertical = function () {
        const currentVertical = getCurrentVertical();
        return !!sport && currentVertical && currentVertical.type === verticalTypesEnum.SPORT;
    };

    const isCasinoVertical = function () {
        return Cookie.read(cookieNames.GAME_VERTICAL_ID)
            === String(AsgFW.GameVerticalCodeToIdEnum.CASINO);
    };

    const setOnReadyEvent = function () {
        $(document).on('fw_asgReady', function () {
            isNgReady = true;
            if (!isNeoCmsIntegrationEnabled() && Games.isGglBrandActive(AsgFW.getBrandID())) {
                AsgFW.setOnGamesListUpdated(Games.updateAllGames);
            }
            if (!isOnSessionStatusUpdateSettled) {
                AsgFW.setOnSessionStatusUpdate(onSessionStatusUpdate);
                isOnSessionStatusUpdateSettled = true;
            }
            onSessionStatusUpdate();
            generateNgFunctions();
            fireAsgReadyEvent();
            checkingCookiePolicyExist();
            setLoginEvents();
            AsgUI.renderStatusBar();
            setFeatureRelatedGameCategories();
            setStatusBarEvents();
            initGeoComplyPopup();

            if (!getIsNativeSsoApp()) {
                showSmartFooter().then(() => {
                    Tools.log('showSmartFooter finished');
                }).catch((e) => {
                    console.error(e);
                });
            }
            if (getIsNativeCopyRightVisible() || !getIsNativeSsoApp()) {
                showCopyright().then(() => {
                    Tools.log('showCopyright finished');
                }).catch((e) => {
                    console.error(e);
                });
            }
            setAppStateToStore();
        });
    };

    const fireAsgReadyEvent = function () {
        $(document).trigger('asgReady');
    };

    /** Function sets 'justLoggedIn' and 'justLoggedOut' events.
     *  Events fire only after calling login/logout functions,
     *  when 'fw_asgReady' &'asgReady' events are already fired
     *  and NOT fire these events on the start of every page load.
     * */
    const setLoginEvents = function () {
        $(document).on('LoggedIn', function () {
            if (!isJustLoggedInSettled) {
                document.dispatchEvent(new Event('justLoggedIn'));
                isJustLoggedInSettled = true;
                isJustLoggedOutSettled = false;
            }
        });

        $(document).on('LoggedOut', function () {
            if (!isJustLoggedOutSettled) {
                document.dispatchEvent(new Event('justLoggedOut'));
                isJustLoggedOutSettled = true;
                isJustLoggedInSettled = false;
            }
        });
    };

    const setFeatureRelatedGameCategories = function () {
        if (AsgApp.isNeoCmsIntegrationEnabled() && window.AsgSharedComponents) {
            const { fillFeatureRelatedGameCategories } = AsgSharedComponents.getActionCreators();

            const brandInitData = AsgFW.getBrandInit();
            const gameCategories = brandInitData?.data?.featureRelatedGameCategories;

            AsgSharedComponents.dispatch(fillFeatureRelatedGameCategories(gameCategories));
        }
    };

    const setStatusBarEvents = function () {
        $(document).on(statusBarEvents, function () {
            AsgUI.renderStatusBar();
        });
    };

    const initGeoComplyPopup = function () {
        if (window.AsgSharedComponents) {
            window.AsgSharedComponents.initGeoComplyPopup();
        }
    };

    const initFlyingNotification = notificationSlug => {
        if (window.AsgSharedComponents) {
            window.AsgSharedComponents.initFlyingNotification(notificationSlug);
        }
    };

    const terminateFlyingNotification = notificationSlug => {
        if (window.AsgSharedComponents) {
            window.AsgSharedComponents.terminateFlyingNotification(notificationSlug);
        }
    };

    const getExternalLoyaltyApiData = () => {
        if (!window.AsgSharedComponents
            || !window.LoyaltyModule
            || window.LoyaltyModule.services.GeneralLoyaltyDataService.isOneOfDefaultPlansUsed()
        ) {
            return;
        }

        const planCode = window.LoyaltyModule.services.GeneralLoyaltyDataService.getLoyaltyPlan();
        const asyncAction = window.LoyaltyModule.enums.LoyaltyPlanApiCallActionsEnum[planCode];

        AsgSharedComponents.dispatch(asyncAction());
    };

    const balanceUpdateUkMode = function () {
        return window.getFrameworkPreferences().balanceUpdateUkMode;
    };

    const getFrameworkUri = function () {
        return frameworkUri;
    };

    /**
     * URI for wp ajax requests
     */
    const getAjaxUri = () => ajaxUri;

    /**
     * Current language
     * e.g. ENG, GER ...
     * @returns {*}
     */
    const getLng = function () {
        return lng;
    };

    const getDefaultLng = function () {
        return defaultLng;
    };

    const getCurrency = function () {
        return currency;
    };

    const getThemeUri = function () {
        return themeUri;
    };

    const getUniversalImagesUri = function () {
        return universalImagesUri;
    };

    const getGeneralImagesUri = function () {
        return generalImagesUri;
    };

    const getCrmImagesUri = function () {
        return crmImagesUri;
    };

    const getGameThumbImagesUri = function () {
        return gameThumbImagesUri;
    };

    const getBrandDomain = function () {
        const domainArr = document.location.hostname.split('.');
        if (domainArr[0] === 'www') domainArr.shift();
        if (lngPossibleArr.includes(domainArr[0].toLowerCase())) domainArr.shift();
        if (regPossibleArr.includes(domainArr[0].toLowerCase())) domainArr.shift();
        // RegExp removes env prefix variations from the hostname.
        if (/(\b|[_-])(dev|qa|uat)([_-]|\b)/i.test(domainArr[0].toLowerCase())) domainArr.shift();
        return domainArr.join('.');
    };

    /**
     * Assign Google Analytics event tracking parameter
     * @param {String} evCat - event category
     * @param {String} evAct - event action
     * @param {String} evLab - event label
     *
     */
    const GAeventTracking = function (evCat, evAct, evLab) {
        const evCatFinal = replaceDynamicParameter(evCat);
        const evActFinal = replaceDynamicParameter(evAct);
        const evLabFinal = replaceDynamicParameter(evLab);

        if (typeof ga !== 'undefined' && Object.prototype.hasOwnProperty.call(ga, 'getAll') && ga.getAll().length > 0) {
            const trackerName = ga.getAll()[0].get('name');
            ga(`${trackerName}.send`, 'event', {
                eventCategory: evCatFinal,
                eventAction: evActFinal,
                eventLabel: evLabFinal,
            });
        }
        if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
                event: 'trackEvent',
                eventCategory: evCatFinal,
                eventAction: evActFinal,
                eventLabel: evLabFinal,
            });
        }
    };

    const eventTrack = function (event) {
        if (eventTrackTmpFlag) {
            const params = {
                event_name: event,
                env: Tools.getEnvPrefix(),
                data: {
                    CasinoId: AsgFW.getBrandID(),
                    EventName: event,
                },
            };

            $.ajax({
                url: `${AsgFW.getAzureAPIUrl()}event_track.php`,
                type: 'POST',
                data: params,
            }).done(function (data) {
                console.log(data);
            })
                .fail(function (jqXHR) {
                    console.log(jqXHR);
                });
        } else {
            const url = `${AsgApp.getFrameworkUri().replace('asg-framework/', '')}services/asgapi/track_event`;
            $.post(url, {
                event_name: event,
                casino_id: AsgFW.getBrandID(),
                env: Tools.getEnvPrefix(),
            });
        }
    };

    const replaceDynamicParameter = function (str) {
        let result = Tools.replaceAll(str, '[user-status]', getUserStatusText());
        result = Tools.replaceAll(result, '[page-name]', getPageNameText());
        result = Tools.replaceAll(result, '[existingPlayers]', gestatesExistingUser());
        result = Tools.replaceAll(result, '[game-name]', getCurrentGame());
        result = Tools.replaceAll(result, '[category]', getCurrentCategory());
        return result;
    };

    const getCurrentCategory = function () {
        return 9;
    };

    const gestatesExistingUser = function () {
        if (Player.isLoggedIn()) {
            return '';
        }

        if (Player.isRegistered()) {
            return 'existing players';
        }
        return 'new players';
    };

    const getUserStatusText = function () {
        return Player.isLoggedIn() === true ? 'post' : 'pre';
    };

    const getPageNameText = function () {
        return window.location.pathname === '/' ? 'Main Screen' : window.location.pathname;
    };

    function setElementEvents(elem, foundElementsCount) {
        let localFoundElementsCount = foundElementsCount;
        $(`${elem} [data-action]`).each(function () {
            localFoundElementsCount += 1;
            $(this).off('click.asgApp');
            $(this).on('click.asgApp', function (e) {
                if (this.href && this.getAttribute('href') === '') {
                    e.preventDefault();
                }

                const methodsRequiringClickEvent = [
                    'openPaymentMethodsPopup',
                    'openFirstVertical',
                ];
                const functionName = $(this).data('action');
                if (typeof AsgApp[functionName] === 'function') {
                    const functionValue = $(this).data('actionInfo');

                    if (functionValue) {
                        if (functionName === 'navigateTo') {
                            AsgApp[functionName](functionValue, false, $(this));
                        } else if (functionName === 'openInfoPopup') {
                            AsgApp[functionName](functionValue, e);
                        } else if (methodsRequiringClickEvent.includes(functionName)) {
                            AsgApp[functionName](e);
                        } else {
                            AsgApp[functionName](functionValue);
                        }
                    } else {
                        AsgApp[functionName]();
                    }
                }
            });
        });
        return localFoundElementsCount;
    }

    function setGAEvents(elem, foundElementsCount) {
        let localFoundElementsCount = foundElementsCount;
        $(`${elem} [data-event="ev"]`).each(function () {
            const that = $(this);
            localFoundElementsCount += 1;
            that.off('click.ga');
            that.on('click.ga', function () {
                const evCat = that.data('gaCategory') ? that.data('gaCategory') : '';
                const evAct = that.data('gaAction') ? that.data('gaAction') : '';
                const evLab = that.data('gaLabel') ? that.data('gaLabel') : '';
                const asgTrk = that.data('asgTrack') ? that.data('asgTrack') : '';

                AsgApp.GAeventTracking(evCat, evAct, evLab);
                if (asgTrk) {
                    AsgApp.eventTrack(asgTrk);
                }
            });
        });
        return localFoundElementsCount;
    }

    const setActionEvents = function (elem) {
        const localElem = elem || '';
        let foundElementsCount = 0;
        foundElementsCount = setElementEvents(localElem, foundElementsCount);
        foundElementsCount = setGAEvents(localElem, foundElementsCount);
        return foundElementsCount;
    };

    const setActionEventsAsync = function (elem) {
        const localElem = elem || '';
        return new Promise((resolve) => {
            setTimeout(() => {
                setElementEvents(localElem, 0);
                resolve();
            }, 50);
        })
            .then(() => {
                setTimeout(() => {
                    setGAEvents(localElem, 0);
                }, 50);
            });
    };

    const unsetActionEvents = function (elem) {
        const localElem = elem || '';
        $(`${localElem} [data-action]`).each(function () {
            $(this).off('click.asgApp');
        });

        $(`${localElem} [data-event="ev"]`).each(function () {
            $(this).off('click.ga');
        });
    };

    const showRegistrationOrLogin = function (paramsObj) {
        closeWalkThroughIfOpen();
        if (AsgFW.isRegistered()) {
            AsgFW.showLogin();
        } else {
            showRegistration(paramsObj);
        }
    };

    const showLogin = function () {
        closeWalkThroughIfOpen();
        AsgFW.showLogin();
    };

    const showRegistration = function (paramsObj) {
        closeWalkThroughIfOpen();
        if (isSportActive() && !Cookie.read(cookieNames.GAME_VERTICAL_ID)) {
            $(document).trigger('missingOrientation');
        } else {
            AsgFW.showRegistration(paramsObj);
        }
    };

    // Function displays Deposit popup.
    const showDeposit = function () {
        closeWalkThroughIfOpen();
        if (AsgFW.isLoggedIn()) {
            if (isAllowedToDeposit()) {
                AsgFW.showDeposit(); // Shows the Deposit popup.
            }
        } else {
            onLoginCallbackFunc = showDeposit;
            showRegistrationOrLogin();
        }
    };

    const onLoginCallback = function () {
        if (onLoginCallbackFunc) {
            onLoginCallbackFunc();
        }
    };

    // Function defines who is allowed to make a deposit (filter by conditions).
    const isAllowedToDeposit = function () {
        // Allow deposit by default.
        return true;
    };

    const playNow = function () {
        let locationRedirect;
        if (isNgFwReady()) {
            if (Player.isLoggedIn()) {
                const defaultLocationSport = getDefaultLocationForVerticalType('sport');
                locationRedirect = defaultLocationSport !== null && isSportVertical()
                    ? defaultLocationSport
                    : '/';
                window.location.href = locationRedirect;
            } else {
                showRegistrationOrLogin();
            }
        }
    };

    /**
     * Executes the action, provided in the data, according to action value.
     * It's recommended to use it with 'click' event on the link/button with
     * specified data attributes ('data-btn-ation' and 'data-btn-action-value').
     * @param object data - is a dataset object with presumed properties
     * 'btnAction' and 'btnActionValue'
     * btnAction - could be: 'widget', 'link' or 'game'.
     * btnActionValue - is a name of the widget method to call, a link value
     * or a game ID accordingly.
     */
    const execBtnAction = data => {
        const action = data.btnAction;
        if (action === 'widget' && shouldUseEventEmitter()) {
            execBtnActionWithEventEmitter(data);
        } else if (isNgFwReady()) {
            execBtnActionWithAsgApp(data);
        }
    };

    const shouldUseEventEmitter = () => getIsOneOfNativeApps() && window.AsgSharedComponents;

    const execBtnActionWithEventEmitter = data => {
        const { NativeEventEmitterService } = AsgSharedComponents.services;
        const eventAction = data.btnActionValue;
        const eventData = {
            isLoggedIn: Player.isLoggedIn(),
        };

        NativeEventEmitterService.emit(eventAction, eventData, mobileOsType);
    };

    const execBtnActionWithAsgApp = data => {
        if (!Player.isLoggedIn() && data.name === '') {
            showRegistrationOrLogin();
            return;
        }

        switch (data.btnAction) {
        case 'widget':
            AsgFW[data.btnActionValue]();
            break;
        case 'link':
            location.href = data.btnActionValue;
            break;
        case 'game':
            if (Games.getGameById(data.btnActionValue)) {
                loadGame(`${data.btnActionValue}|M`);
            } else {
                location.href = '/';
            }
            break;
        default:
            Tools.log('Button action could not be performed.');
        }
    };

    const execPromotionCTA = data => {
        if (shouldUseEventEmitter()) {
            execPromotionCtaWithEventEmitter(data);
        } else if (isNgFwReady()) {
            execPromotionCtaWithAsgApp(data);
        }
    };

    const execPromotionCtaWithEventEmitter = data => {
        const { NativeEventEmitterService } = AsgSharedComponents.services;
        const eventAction = data.btnAction;
        const eventData = {
            isLoggedIn: Player.isLoggedIn(),
            gameId: eventAction === 'game' ? data.btnActionValue : null,
        };

        NativeEventEmitterService.emit(eventAction, eventData, mobileOsType);
    };

    const execPromotionCtaWithAsgApp = data => {
        switch (data.btnAction) {
        case 'Registration':
            showRegistrationOrLogin();
            break;
        case 'game':
            if (Games.getGameById(data.btnActionValue)) {
                loadGame(`${data.btnActionValue}|M`);
            } else {
                location.href = '/';
            }
            break;
        case 'provider_page':
        case 'sport_league':
            navigateTo(data.btnActionValue);
            break;
        case 'show_deposit':
            showDeposit();
            break;
        default:
            Tools.log('Button action could not be performed.');
        }
    };

    const setDefaultGameVerticalID = function (orientation) {
        AsgFW.setDefaultGameVerticalID(orientation);
    };

    const setGameVerticalIdCookie = function (verticalId) {
        Cookie.create(cookieNames.GAME_VERTICAL_ID, verticalId, '180', '/');
    };

    const playNowWithOrientationCheck = function (orientation) {
        if (isNgFwReady()) {
            if (Player.isLoggedIn()) {
                redirectToVerticalPageById(orientation);
            } else {
                if (isSportActive()) {
                    setDefaultGameVerticalID(orientation);
                    setGameVerticalIdCookie(orientation);
                }
                showRegistrationOrLogin();
            }
        }
    };

    const redirectToVerticalPageById = (platformVerticalId) => {
        let redirectionHref = AsgFW.GameVerticalIdToSlugEnum[platformVerticalId]
            ? `/${AsgFW.GameVerticalIdToSlugEnum[platformVerticalId]}`
            : '/';

        const platform = getPlatformName();
        const verticals = getVerticals().byOrder[platform];
        const verticalCode = AsgFW.GameVerticalIdToCodeEnum[platformVerticalId] || '';

        const matchedVerticalsLocation = verticals
            .filter((vertical) => (vertical.type === verticalCode));

        if (matchedVerticalsLocation.length) {
            redirectionHref = matchedVerticalsLocation[0].altLocation
                || matchedVerticalsLocation[0].location;
        }

        if (redirectionHref) {
            window.location.href = redirectionHref;
        }
    };

    const onSessionStatusUpdate = function () {
        getBannerData();
        setRegulationTerms();
        if (Player.isLoggedIn()) {
            Player.onLogin();
        } else {
            Player.onLogout();
        }
    };

    const logout = function () {
        Player.logout();
    };

    /**
     * Used for T2 only. Declared in menu.json
     * @param language
     */
    const changeLanguage = function (language) {
        if (language === getLng()) return;
        triggerLoadingScreen();
        const newLng = lng3ToLng2(language);
        let newUrl;
        const queryString = UrlService.updateQueryString('lng', null, window.location.search);
        if (newLng) {
            if (language === getDefaultLng()) {
                newUrl = UrlService.updateQueryString('lng', getDefaultLng(), `https://${AsgFW.getBrandDomainWithEnvPrefix()}${window.location.pathname}${queryString}`);
            } else {
                const mapLng2ToRegion = {
                    ce: 'on',
                };
                const locale = Object.keys(mapLng2ToRegion).includes(newLng)
                    ? mapLng2ToRegion[newLng]
                    : newLng;

                newUrl = `https://${locale}.${AsgFW.getBrandDomainWithEnvPrefix()}${window.location.pathname}${queryString}`;
            }
            window.location.href = newUrl;
        }
    };

    const lng3ToLng2 = function (lng3) {
        const lngArr = {
            ENG: 'en',
            ENC: 'ce',
            GER: 'de',
            RUS: 'ru',
            SPA: 'es',
            FRE: 'fr',
            DAN: 'dk',
            ITA: 'it',
            DUT: 'nl',
            FIN: 'fi',
            POR: 'pt',
            BRA: 'br',
            JPN: 'jp',
            NOR: 'no',
        };
        return lngArr[lng3] || false;
    };

    const triggerLoadingScreen = function () {
        document.dispatchEvent(new Event('loading'));
    };

    const navigateTo = function (url, newWindow, event) {
        // Define the search parameters, that should be removed from the URL.
        let ignoredParameters = ['neodl', 'force'];
        let newUrl;

        if (getDefaultLng() === AsgFW.getLanguage()) {
            ignoredParameters.push('lng');
        }

        if (event && typeof event[0].href !== 'undefined' && event[0].href !== '') {
            return;
        }

        const isSameHost = UrlService.isSameHost(url);

        // Create the new URL version with the joined search parameters, if the host is the same.
        newUrl = isSameHost
            ? UrlService.joinCurrentUrlSearchParams(url)
            : url;

        // Remove forced parameters from the ignored parameters list (use like force=NeoDL)
        const forceParam = new URLSearchParams(new URL(newUrl).search)
            .getAll('force')
            .map(param => param.toLowerCase());
        if (forceParam.length) {
            ignoredParameters = ignoredParameters.filter(
                (param) => !forceParam.includes(param.toLowerCase()),
            );
        }

        // Delete ignored parameters
        ignoredParameters.forEach((param) => {
            newUrl = UrlService.deleteParameter(param, newUrl);
        });

        // Open the URL in the new window
        if (newWindow || !isSameHost) {
            window.open(newUrl);
        } else {
            // Open the URL at the same page
            window.location.href = newUrl;
        }
    };

    const openInfoPopup = function (url, event) {
        $(document).trigger('infoPageClicked');
        event.preventDefault();
        event.stopImmediatePropagation();

        if (!url) {
            return;
        }

        let localUrl = url;

        switch (localUrl.toLowerCase()) {
        case 'helpdepositmethods.aspx':
            return openPaymentMethodsPopup(event);
        case 'helpforgotpassword.aspx':
            ng_fw.showForgotPassword();
            break;
        case 'helpdeposit.aspx':
            if (isPayNPlayEnabled()) {
                localUrl = 'helpDepositTrustly.aspx';
            }
            break;
        default:
            break;
        }

        let originalParams = '';
        // If there are url params
        if (/.+\.aspx\?(.+)/.test(localUrl)) {
            const urlWithParams = localUrl.split('?');
            // remove them from url
            // eslint-disable-next-line prefer-destructuring
            localUrl = urlWithParams[0];
            // store original params in order to chain them later
            originalParams = `&${urlWithParams[1]}`;
        }

        const envPrefix = Tools.getEnvPrefix();
        const showRgQuestionnaire = AsgFW.getRbcSettings('showRgQuestionnaire') ?? true;

        const query = new URLSearchParams({
            ...AsgFW.getSolarBaseParams(),
            brandDomain: AsgApp.getBrandDomain(),
            page: localUrl,
            lng: AsgApp.getLng(),
            casinoId: AsgFW.getBrandID(),
            env: envPrefix,
            showRgQuestionnaire,
        });

        const pamInfoPagesServiceUrl = AsgFW.isNeoCmsIntegrationEnabled()
            && AsgFW.getPamUrlInfoPages();
        if (pamInfoPagesServiceUrl) {
            query.set('pamInfoPagesServiceUrl', pamInfoPagesServiceUrl);
        }

        // detect CurrencyCode param for info page content
        if (AsgFW.isLoggedIn()) {
            query.set('CurrencyCode', AsgFW.getDisplayBalance().Currency);
        } else {
            const currencyCode = AsgApp.getCurrency();
            if (currencyCode) {
                query.set('CurrencyCode', currencyCode);
            }
        }

        const params = `${query.toString()}${originalParams}`;

        const paramsObj = Tools.getParameters(params);
        const hasGameid = Object.prototype.hasOwnProperty.call(paramsObj, 'gameid');
        const gameId = hasGameid ? paramsObj.gameid : null;
        $.get(`${AsgFW.getAsgAPIUri()}getInfoPage?${params}`, function (data) {
            const html = $.parseHTML(data.data.result).find(tag => tag.id === 'aspnetForm');
            const UKSelectorClass = AsgApp.isUkCountry() && !!$(html).find('.info-uk-only .StandardPageLeftSectionContentTitle').length ? '.info-uk-only ' : '';
            let title = $(html).find(`${UKSelectorClass}.StandardPageLeftSectionContentTitle:first, ${UKSelectorClass}.PopUpPageWithBorderContentTitle:first`)[0];
            title = title || (gameId ? Games.getGameNameById(gameId) : '');
            $(html).find('.StandardPageLeftSectionContentTitle:first, .PopUpPageWithBorderContentTitle:first').remove();
            const body = $(html);
            let callback = null;

            const hasScript = Object.prototype.hasOwnProperty.call(data.data, 'script');
            if (hasScript) {
                $(body).prepend(`<script>${data.data.script}</script>`);
            }

            const hasStyle = Object.prototype.hasOwnProperty.call(data.data, 'style');
            if (hasStyle) {
                $(body).prepend(`<style>${data.data.style}</style>`);
            }

            const hasPage = Object.prototype.hasOwnProperty.call(data.data, 'page');
            const chatRequiresLogin = AsgFW.chatRequiresLogin();
            if (hasPage) {
                if (data.data.page === 'responsible') {
                    callback = function () {
                        window.onload();
                        $(document).trigger('infoPopupReady');
                    };
                }

                if (data.data.page === 'faq') {
                    const faqHTMLAddition = buildFaqHTMLAddition();
                    body.prepend(faqHTMLAddition);
                    if (!AsgFW.isLoggedIn() && chatRequiresLogin) {
                        body.find('.asg-faq-contact-us-live-chat-btn').addClass('hide');
                    }
                    title = Dictionary.translate('header');
                }
            }
            const msg = {
                customClass: 'info-popup',
                head: title,
                body,
                customCss: AsgFW.isMobilePamPlatform() ? { width: '90%' } : { width: '70%' },
            };
            AsgUI.popUpNotification(msg, callback);
        });
    };

    const isTop5FaqShown = () => AsgFW.getRbcSettings('showTop5FAQ');

    const buildFaqHTMLAddition = function () {
        let top5FAQ = '';
        if (isTop5FaqShown()) {
            let accordion = '';
            for (let i = 1; i <= 5; i += 1) {
                const question = Dictionary.translate(`question${i}`);
                accordion += `<dt><a data-event="ev" data-ga-category="FAQ" data-ga-action="[user-status] login top 5 FAQ’s" data-ga-label="Click ${question}" 
                                    class="question" data-question-item="${i}">${question}</a></dt><dd data-answer-item="${i}"></dd>`;
            }
            top5FAQ = `<div class="accordion-container">
                    <h3>${Dictionary.translate('top5FAQ')}</h3>
                    <dl class="accordion">
                        ${accordion}
                    </dl>
                </div>`;
        }
        let html = `<div id="faq-injected-content" class="faq-injected-content">
                <div class="input-group stylish-input-group">
                    <input type="text" id="question-input" class="form-control primary-bgcolor primary-textcolor" placeholder="${Dictionary.translate('askAQuestion')}"
                        data-event="ev" data-ga-category="FAQ" data-ga-action="[user-status] login search">
                    <span class="input-group-addon primary-bgcolor">
                        <button type="submit" class="icon-search">
                            <span class="glyphicon glyphicon-search"></span>
                        </button>
                    </span>
                </div>
                <ul class="results third-bgcolor"></ul>
                ${top5FAQ}
                <div class="asg-faq-contact-us-right-wrap">
                    <span onclick="AsgFW.showChat()" class="asg-faq-contact-us-live-chat-btn asg-faq-contact-us-btn" data-action="showChat">
                        <span class="asg-faq-contact-us-live-chat-icon">
                            <svg  class="asg-faq-btn-svg"  data-name="Isolation Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128.31 101.46"><defs><style>.cls-1{fill:#ededed;}</style></defs><path class="cls-1" d="M118.62,1.42H55.2A11.12,11.12,0,0,0,44.1,12.53v3.89H13.6A12.23,12.23,0,0,0,1.38,28.64v40A12.23,12.23,0,0,0,13.6,80.86H25.86v19a3,3,0,0,0,1.87,2.78,3.2,3.2,0,0,0,1.13.22A3,3,0,0,0,31,102l20.4-21.11H69.71c8.71,0,12.81-3.42,14.67-7.27L99.71,89.17a3,3,0,0,0,2.14.9,3.05,3.05,0,0,0,1.14-.23,3,3,0,0,0,1.86-2.77V67.71h13.77a11.08,11.08,0,0,0,11.07-11.07V12.49A11.08,11.08,0,0,0,118.62,1.42ZM69.71,74.86H50.15a3,3,0,0,0-2.16.91L31.86,92.47V77.86a3,3,0,0,0-3-3H13.6a6.23,6.23,0,0,1-6.22-6.22v-40a6.23,6.23,0,0,1,6.22-6.22H44.1V56.6A11.12,11.12,0,0,0,55.2,67.71H78.59l1.07,1.08C79.17,72,77.09,74.86,69.71,74.86Zm54-18.22a5.08,5.08,0,0,1-5.07,5.07H101.85a3,3,0,0,0-3,3v15L82,62.6a3,3,0,0,0-2.14-.89H55.2a5.11,5.11,0,0,1-5.1-5.11V22.42h.06v-6H50.1V12.53a5.11,5.11,0,0,1,5.1-5.11h63.42a5.08,5.08,0,0,1,5.07,5.07Z" transform="translate(-1.38 -1.42)"/><path class="cls-1" d="M108.62,23.16h-43a3,3,0,0,0,0,6h43a3,3,0,0,0,0-6Z" transform="translate(-1.38 -1.42)"/><path class="cls-1" d="M78.62,40.16h-13a3,3,0,0,0,0,6h13a3,3,0,0,0,0-6Z" transform="translate(-1.38 -1.42)"/></svg>
                        </span>
                        <span class="asg-faq-btn-text">
                            ${Dictionary.translate('liveChatButtonText')}
                        </span>
                    </span>
                    <a href="/contact-us/" class="asg-faq-contact-us-email-btn asg-faq-contact-us-btn">
                        <span class="asg-faq-contact-us-email-icon">
                            <svg  class="asg-faq-btn-svg" data-name="Isolation Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 125.53 88.77"><defs><style>.cls-1{fill:#ededed;}</style></defs><path class="cls-1" d="M120.12,7.77H11A8.2,8.2,0,0,0,2.77,16V88.35A8.21,8.21,0,0,0,11,96.54H120.12a8.21,8.21,0,0,0,8.19-8.19V16A8.2,8.2,0,0,0,120.12,7.77Zm-2.91,6.34L66.91,64a2,2,0,0,1-2.74,0L13.87,14.11Zm-108.1,71V18.32L41,49.88ZM13,90.2,45.47,54.35,59.7,68.45a8.32,8.32,0,0,0,11.67,0l14-13.88L118,90.2Zm109-5.07-32.07-35L122,18.32Z" transform="translate(-2.77 -7.77)"/></svg>
                        </span>
                        <span class="asg-faq-btn-text">
                            ${Dictionary.translate('emailButtonText')}
                        </span>
                    </a>
                </div> 
            </div>`;

        html = Tools.replaceAll(html, '[BrandName]', Tools.capitalize(AsgFW.getBrandName()));
        return html;
    };

    const openPaymentMethodsPopup = function (e) {
        e.preventDefault();
        const isDe = AsgFW.isDEregulation();
        const contentReady = Tools.deferred();
        const countryCode = AsgFW.getCurrentCountry();
        const regulationCode = AsgFW.getRegulation();
        let resultTableCurrency = '';

        const prepareDataCb = (data) => {
            const title = data.data.content.DepositMethodTableTitle;

            let html = '<div class="inner-page"><div class="content-info-page col-xs-12" style="padding: 0!important;">';
            html += '<h4 class="paymentMethodTitle"></h4>';
            html += `<p>${data.data.content.paymentMethodText1}</p>`;
            html += `<p>${data.data.content.paymentMethodText2}</p>`;
            html += `<h4 class="DepositMethodTableTitle">${data.data.content.paymentMethodTitle}</h4>`;
            html += '<table class="ContentInnerTable paymentMethodTable"><tbody>';
            html += '<tr class="top table-header">';
            data.data.table.title.forEach(function (item, index) {
                if (index === 0) {
                    html += `<td class="PaymentMethodsleft"><span><b>${item}</b></span></td>`;
                } else {
                    html += `<td class="PaymentMethodsrigth"><b>${item}</b></td>`;
                }
            });
            html += ' </tr>';
            for (const [, value] of Object.entries(data.data.table.body)) {
                resultTableCurrency = value.availableCurrency;

                if (isDe && value.name === 'Trustly') {
                    resultTableCurrency = '&euro;';
                }

                html += `<tr class="popup-divider ${value.name}-payment-name"><td class="PaymentMethodsleft ${value.name}-payment-name"><div></div></td> <td class="PaymentMethodsrigth ${value.name}-paymant-name" colspan="3"><div></div></td></tr>`;
                html += `<tr class="top ${value.name}-payment-name">`;

                let link = Tools.getLinkTargetAttrPopup(value.link, value.paymentLinkOpen);

                // disable link in case no href provided from API
                if (!value.link) {
                    link = 'onclick="((e)=>{e.preventDefault()})(event)"';
                }

                html += `<td class="PaymentMethodsleft ${value.name}-payment-name"><span><a class="ContentLinks" ${link} ><img alt="${value.name}" src="${value.logo}" border="0"></a></span></td>`;

                html += `<td class="PaymentMethodsrigth"><span>${value.depositTime}</span></td>`;
                html += `<td class="PaymentMethodsrigth"><span>${value.withdrawalTime}</span></td>`;
                html += `<td class="PaymentMethodsrigth"><span>${resultTableCurrency}</span></td>`;
                html += '</tr>';
            }
            html += '</tbody></table></div></div>';

            contentReady.resolve({ title, html });
        };

        getSolarPaymentMethodsForPopup(countryCode, regulationCode, prepareDataCb);

        contentReady.then(({ title, html }) => {
            const msg = {
                customClass: 'info-popup',
                head: title,
                body: html,
                customCss: AsgFW.isMobilePamPlatform() ? { width: '90%' } : { width: '60%' },
            };

            AsgUI.popUpNotification(msg);
        });
    };

    const getSolarPaymentMethodsForPopup = (countryCode, regulationCode, cb) => {
        const resultMethods = {};

        SolarAPI.get(
            '/api/v1/brands/{casinoId}/payment-methods',
            {
                country: countryCode,
                reg: regulationCode,
            },
            (solarResponse) => {
                const { data } = solarResponse;
                Object.keys(data.paymentMethods).forEach((pmName) => {
                    let hrefValue = null;
                    const paymentObj = data.paymentMethods[pmName];
                    if (paymentObj.paymentLink) {
                        hrefValue = paymentObj.paymentLink;
                    }
                    resultMethods[pmName] = {
                        availableCurrency: paymentObj.availableCurrencies,
                        depositTime: Dictionary.translate(paymentObj.depositTime),
                        withdrawalTime: Dictionary.translate(paymentObj.withdrawalTime),
                        link: hrefValue,
                        logo: paymentObj.paymentLogo,
                        name: pmName,
                        paymentLinkOpen: paymentObj.paymentLinkOpen,
                    };
                });

                const paymentMethodsResult = {
                    data: {
                        content: {
                            paymentMethodTitle: Dictionary.translate(data.page.title),
                            paymentMethodText1: Dictionary.translate(data.page.paragraph1).replace(/\[BrandName\]/g, getBrandDomain()),
                            paymentMethodText2: Dictionary.translate(data.page.paragraph2),
                            DepositMethodTableTitle: Dictionary.translate(data.page.tableTitle),
                        },
                        table: {
                            title: [
                                Dictionary.translate(data.page.tableColumn1),
                                Dictionary.translate(data.page.tableColumn2),
                                Dictionary.translate(data.page.tableColumn3),
                                Dictionary.translate(data.page.tableColumn4),
                            ],
                            body: resultMethods,
                        },
                    },
                };
                cb(paymentMethodsResult);
            },
        );
    };

    const showChat = function () {
        const playerStatus = Player.isLoggedIn() ? 'post' : 'pre';
        const evLab = `Open chat ${playerStatus} login`;
        AsgApp.GAeventTracking('Main Screen', 'Chat', evLab);
        const chatRequiresLogin = AsgFW.chatRequiresLogin();

        if (Player.isLoggedIn() || !chatRequiresLogin) {
            AsgFW.showChat();
        } else {
            const msg = {
                head: Dictionary.translate('welcome'),
                body: Dictionary.translate('loginToAccessChat'),
                btn: Dictionary.translate('login'),
                action: 'AsgApp.showLogin()',
                customCss: AsgFW.isMobilePamPlatform() ? { width: '100%' } : { width: '20%' },
                bottom: `<a class="new-around" onclick="AsgApp.showRegistration(); $('#popup-notification .close').click()">${Dictionary.translate('newAroundHere')}</a>`,
            };

            AsgUI.popUpNotification(msg);
            chatAfterLogin = true;
        }
    };

    const showContactUs = function (event) {
        AsgFW.showContactUs();

        // Prevent a default browser action, if this function
        // was called as the click action on the link.
        if (event) {
            event.preventDefault();
        }
    };

    const showMyAccount = function () {
        AsgFW.showMyAccount();
    };

    const showChangePassword = function () {
        AsgFW.showChangePassword();
    };

    const showGamesHistory = function () {
        AsgFW.showGamesHistory();
    };

    const showTransactionsHistory = function () {
        AsgFW.showTransactionsHistory();
    };

    const showDepositLimit = function () {
        AsgFW.showDepositLimit();
    };

    const showSelfExclusion = function () {
        AsgFW.showSelfExclusion();
    };

    const getCurrentGame = function () {
        return currentGame;
    };

    const getCurrentGameId = function () {
        return currentGameId;
    };

    const loadGame = function (data) {
        const gameID = data.split('|')[0];
        const isGamePage = data.split('|')[2] || false;
        let playMode = isNoDemoGamesCountry() && !isGamePage ? 'M' : data.split('|')[1];
        let timeGepForLoadGameTrigger = 0;
        if (playMode === 'Z') {
            // for new prelogin page flow - play mode Z (logged out) should open game page by URL
            if (!Player.isLoggedIn()) {
                window.location = `/casino/games/${AsgFW.getGameSlug(Games.getGameNameById(gameID))}`;
                return;
            }

            playMode = Player.isLoggedIn() || Games.isNoDemoGame(gameID) ? 'M' : 'D';
        }

        if (bonusWagerPopUp()) {
            timeGepForLoadGameTrigger = 2000;
        }

        setTimeout(function () {
            loadGameAction(gameID, playMode);
            AsgUI.hideOverlay();
        }, timeGepForLoadGameTrigger);
    };

    const loadGameAction = function (gameID, playMode) {
        console.log('%cAsgApp:%c The game load was requested -', 'background-color: #4cb848; color: #fff', '', gameID, playMode);

        if (window.AsgSharedComponents) {
            const { loadGame } = AsgSharedComponents.getActionCreators();
            AsgSharedComponents.dispatch(loadGame({
                gameId: gameID,
                mode: playMode,
            }));
        } else {
            AsgFW.loadGame(gameID, playMode);
        }

        currentGameId = gameID;
        currentGame = Games.getGameNameById(gameID);
        $(document).trigger('loadGame', { gameId: gameID, playMode });
    };

    const switchToMoneyMode = function () {
        if (Player.isLoggedIn()) {
            const gameName = getCurrentGame();
            const gameObj = Games.getGameByName(gameName);
            if (gameObj) {
                AsgFW.loadGame(gameObj.id, 'M');
            }
        }
    };

    const iSoftBetDataLoad = function () {
        $.getJSON(`${AsgFW.getFrameworkUri()}data/general-data/iSoftBetGameSetting.json`, function (response) {
            iSoftBetData = response.GameListId;
        });
    };

    const getDomainSuffixes = function () {
        const domainBrandArr = getBrandDomain().split('.');
        const domainBrandArrLength = domainBrandArr.length - 1;
        return domainBrandArr[domainBrandArrLength];
    };

    const isGameNeedISoftBetPopUp = function (gameID) {
        return (Player.isLoggedIn() && jQuery.inArray(gameID, iSoftBetData) > -1 && country !== 'uk' && getDomainSuffixes() !== 'dk');
    };

    const bonusWagerPopUp = function () {
        if (country === 'uk') {
            if (AsgApp.getDisplayBalance().BonusBalance > 0) {
                Cookie.create('bonusWagerMessage', '1', '180');
                AsgUI.showPopup('bonus-wager-enter');
                return true;
            }

            if (Cookie.read('bonusWagerMessage') === '1' && Player.isLoggedIn()) {
                Cookie.remove('bonusWagerMessage');
                AsgUI.showPopup('bonus-wager-exit');
                return true;
            }
        }
        return false;
    };

    const closeGame = function (showMessage = false) {
        AsgFW.closeGame();
        if (ExitGameMessage) {
            ExitGameMessage.isNeedToShow = showMessage;
        }
    };

    const showWithdraw = function () {
        AsgFW.showWithdraw();
    };

    const showMyRewards = function () {
        AsgFW.showMyRewards();
    };

    const showGameSearch = function () {
        $(document).trigger('showGameSearch');
    };

    const showRealityCheck = function () {
        AsgFW.showRealityCheck();
    };

    const getLoyaltyPoints = function () {
        return AsgFW.getLoyaltyPoints();
    };

    const showDocumentUpload = function () {
        return AsgFW.showDocumentUpload();
    };

    const getDisplayBalance = function () {
        return AsgFW.getDisplayBalance();
    };

    const generateNgFunctions = function () {
        AsgFW.setLoadGameStart(InGame.openInGame);
        AsgFW.setLoadGameClosed(InGame.closeInGame);

        $(document).on('fw_balanceUpdated', function () {
            $(document).trigger('balanceUpdated');
        });

        $(document).on('fw_playerPopupBanner', function () {
            $(document).trigger('playerPopupBanner');
        });

        $(document).on('fw_registrationSucceeded', function () {
            if (isPhoneGap) {
                Phonegap.fireAppsflyerEvent('af_registration');
            }
            $(document).trigger('registrationSucceeded');
        });

        $(document).on('fw_depositSucceeded', function () {
            $(document).trigger('depositSucceeded');
        });
    };

    isPhoneGap = function () {
        return isPhoneGap;
    };

    // eslint-disable-next-line camelcase
    const ng_openPage = function (key, customInfo) {
        let url;
        let newWindow = true;
        switch (key) {
        case 'Swish':
            openSwishApp(customInfo);
            break;
        case 'Play':
            url = '#';
            newWindow = false;
            break;
        case 'ResponsibleGaming':
            url = '/info/responsible/';
            break;
        case 'FAQ':
            if (customInfo === 'UploadDocuments') {
                url = '/info/help-au10tix-upload-documents/';
            } else {
                url = '/info/faq/';
            }
            break;
        case 'BonusPolicy':
            url = '/info/bonus-policy/';
            break;
        case 'Bonuses':
        case 'RewardPoints':
            url = '/info/faq/';
            break;
        case 'MyLiveRewards': // PlayLive specific Rewards loyalty page.
            url = '/loyalty/';
            break;
        case 'UnsuccessfulDeposit':
            url = '/info/help-deposit-methods/';
            break;
        case 'HelpDeposit':
            switch (customInfo) {
            case 'bycredit':
                url = `${key}creditcard.aspx`;
                break;
            case 'asgprepaidcardplay+':
                url = '/info/help-depositasgprepaidcardplay/';
                break;
            default:
                url = `${key + customInfo.replace('-', '')}.aspx`;
            }
            break;
        case 'email':
            url = '/contact-us/';
            newWindow = false;
            break;
        case 'asyncdeposit':
            url = UrlService.updateQueryString('uiwebview', 'true', url);
            url = UrlService.updateQueryString('neodl', 'deposit', url);
            url = UrlService.updateQueryString('appname', null, url);
            $.each(customInfo, function (k, v) {
                url = UrlService.updateQueryString(k, v, url);
            });
            window.location.href = url;
            return;
        case 'BankIDVerification':
            url = UrlService.updateQueryString('open', '1', customInfo.verificationUrl);
            url = UrlService.updateQueryString('uiwebview', 'true', url);
            window.location.href = url;
            return;
        case 'ResponsibleGamingIcon':
            if (customInfo === 'SelfTest') {
                url = 'https://www.stodlinjen.se/#!/spelberoende-test-pgsi';
            } else {
                url = 'https://www.Spelpaus.se';
            }
            break;
        case 'GamesLobby':
            newWindow = false;
            url = '/';
            break;
        case 'Redirect':
            newWindow = false;
            url = customInfo;
            break;
        case 'Sports':
            if (!isSportVertical()) {
                const platform = getPlatformName();
                const verticals = getVerticals().byOrder[platform];
                if (window.AsgVerticals) {
                    AsgVerticals.services.VerticalService.openSportVertical(verticals);
                }
            }
            return;
        default:
            url = `${key}.aspx`;
        }
        navigateTo(url, newWindow);
    };

    const openSwishApp = function (customInfo) {
        const token = customInfo;
        let callbackurl = window.location.href;
        if (Tools.getBrowserName() === 'Chrome') {
            callbackurl = 'googlechrome://';
        }
        if (isPhoneGap) {
            window.location.replace(`swish://paymentrequest?token=${token}&callbackurl=`);
        } else {
            window.location.replace(`swish://paymentrequest?token=${token}&callbackurl=${callbackurl}`);
        }
        setTimeout(fallbackToStore, 250);
    };

    const fallbackToStore = function () {
        const { userAgent } = window.navigator;
        if (userAgent.match(/Android/i) || isPhoneGap) {
            window.location.replace('https://play.google.com/store/apps/details?id=se.bankgirot.swish');
        } else if (userAgent.match(/iPhone|iPad|iPod/i)) {
            window.location.replace('https://itunes.apple.com/us/app/swish-payments/id563204724?mt=8');
        }
    };

    /**
     Temporary solution - until all download server will be migrated to Azure.
     TODO: remove the function after NG will update URLs on their side
     * Now works only for main banners.
     */
    const setBannerDetails = function (data) {
        const dsEnv = AsgFW.getDsEnv();
        if (data.BannersTypes === null) {
            bannersWeb = data.BannersSets[0].Banners;
            AsgFW.bannersReplaceNGtoAzureStorage(dsEnv, bannersWeb);
        } else {
            for (const key in data.BannersTypes) {
                if (data.BannersTypes[key].BannerTypeCode === 'PlayerLobbyBanners') {
                    bannersWeb = data.BannersTypes[key].BannersSets[0].Banners;
                    AsgFW.bannersReplaceNGtoAzureStorage(dsEnv, bannersWeb);
                } else if (data.BannersTypes[key].BannerTypeCode === 'PlayerSpecialEvents') {
                    const bannersSpecial = data.BannersTypes[key].BannersSets[0].Banners;
                    AsgFW.bannersReplaceNGtoAzureStorage(dsEnv, bannersSpecial);
                } else if (data.BannersTypes[key].BannerTypeCode === 'PlayerPopups') {
                    const bannersPopups = data.BannersTypes[key].BannersSets[0].Banners;
                    AsgFW.bannersReplaceNGtoAzureStorage(dsEnv, bannersPopups);
                }
            }
        }
        $(document).trigger('bannersReady');
    };

    const getbannerLinkType = function (b, elm) {
        const localBanner = b;
        if (localBanner.LinkType === null || localBanner.LinkType === ' ') {
            elm.attr('data-action', 'showDeposit');
        } else {
            switch (localBanner.LinkType) {
            case 'G':
                elm.attr('data-action', 'loadGame').attr('data-action-info', `${localBanner.GameID}|M`);
                elm.data('data-action', 'loadGame').data('action-info', `${localBanner.GameID}|M`);
                break;
            case 'E':
                elm.attr('data-action', 'navigateTo').attr('data-action-info', localBanner.TargetURL);
                elm.data('action', 'navigateTo').data('action-info', localBanner.TargetURL);
                break;
            default:
                elm.attr('data-action', 'showDeposit');
                elm.data('action', 'showDeposit');
            }
        }
    };

    const getBannerData = function () {
        AsgFW.setGetBannerDetails(setBannerDetails);
    };

    const getBannersWeb = function () {
        return AsgFW.getSegmentedBannersWeb();
    };

    const getBannersMobile = function () {
        return AsgFW.getSegmentedBannerMobile();
    };

    const getBannersSpecial = function () {
        return AsgFW.getSegmentedBannerSpecial();
    };

    const getBannersPopups = function () {
        return AsgFW.getSegmentedBannerPopups();
    };

    const setMissingFuncs = function () {
        window.ContactUsPopUp = AsgApp.showContactUs;
        window.OpenPopup = AsgApp.navigateTo;
        window.MailToEmailAddress = AsgApp.showContactUs;
        window.Chat = AsgApp.showChat;
    };

    const setRegulationTerms = function () {
        $('.regulation-skeleton').remove();
        $('.banner-skeleton-image').remove();
        let paramToShow = [];
        const regulationElements = $('.regulation-txt:not(.interactive-banner-regulation)');
        if (regulationElements.length > 0) {
            paramToShow = setRegulationTermsParams();
            $('.regulation-skeleton').remove();
            regulationElements.html(paramToShow.text);

            if (!Player.isLoggedIn()) {
                const casino = regulationElements.find('.casino-regulation-text');
                const sportRegulation = regulationElements.find('.sport-regulation-text');
                casino.off('click touchstart');
                casino.on('click touchstart', function (e) {
                    e.stopPropagation();
                    window.location = paramToShow.link;
                });
                sportRegulation.off('click touchstart');
                sportRegulation.on('click touchstart', function (e) {
                    e.stopPropagation();
                    window.location = paramToShow.sportLink;
                });
                regulationElements.off('click touchstart');
                regulationElements.on('click touchstart', function (e) {
                    e.stopPropagation();
                    window.location = paramToShow.link;
                });
            } else {
                regulationElements.off('click touchstart');
                regulationElements.on('click touchstart', function (e) {
                    e.stopPropagation();
                    window.location = paramToShow.link;
                });
            }
        }
    };

    /**
     * return Regulation Text by HTML format
     * @returns {*|string}
     */
    const getRegulationText = () => {
        let html = asgData.regulationText;
        if (getDomainSuffixes() === 'dk') {
            const seeMore = `<span class="moreText">${Dictionary.translate('RegulationTermsPreLogin')}</span>`;
            html = `${asgData.regulationText} ${seeMore}`;
            if (AsgFW.isMobilePamPlatform()) {
                html = '';
            }
        }
        return html;
    };

    const hasSpecificRegulationText = () => asgData.hasSpecificRegulationText;

    /**
     * return Sport Regulation Text by HTML format
     * @returns {*|string}
     */
    const getSportRegulationHTML = () => {
        let html = '';
        if (!AsgFW.isMobilePamPlatform()) {
            const sportRegulationText = asgData.sportRegulationText || Dictionary.translate('RegulationTermsPreLogin');
            html = `<span style="display: none" class="originalText sport-regulation-text">${sportRegulationText}</span>`;
        } else {
            html = `<span style="display: none" class="originalText sport-regulation-text">${asgData.regulationText}</span>`;
        }
        return html;
    };

    const setRegulationTermsParams = () => {
        let theText;
        let regulationText;
        let theSportLink;

        const [text, link] = AsgFW.getRegulationTextAndLink();
        theText = `<p><span class="originalText">${text}</span></p>`;
        const theLink = customTermsLink.length > 0 ? customTermsLink : link;
        if (!Player.isLoggedIn()) {
            theSportLink = '/promotions/sport-welcome-offer/';

            if (asgData.regulationText) {
                const sportRegulationHTML = getSportRegulationHTML();
                regulationText = getRegulationText();
                theText = `<p><span class="originalText casino-regulation-text">${regulationText}</span>${sportRegulationHTML}</p>`;
            }
        }
        return { text: theText, link: theLink, sportLink: theSportLink };
    };

    /**
     * The function returns full T&C text if it was provided in the WP
     * or text from the Dictionary in the opposite case.
     * @returns string
     */
    const getFullRegulationText = function () {
        const seeMoreTranslation = (Player.isLoggedIn()) ? Dictionary.translate('RegulationTermsPostLogin') : Dictionary.translate('RegulationTermsPreLogin');
        const seeMore = `<span class="see-more-link">${seeMoreTranslation}</span>`;
        if (asgData.regulationText) {
            return `${asgData.regulationText} ${seeMore}`;
        }
        return seeMore;
    };

    const fixStandaloneIOS = function () {
        if (('standalone' in window.navigator) && window.navigator.standalone) {
            let noddy;
            const remotes = false;
            document.addEventListener('load', function () {
                $('a').each(function () {
                    const href = $(this).attr('href');
                    if (href === '') {
                        $(this).removeAttr('href');
                    }
                });
            });
            document.addEventListener('click', function (event) {
                noddy = event.target;
                while (noddy.nodeName !== 'A' && noddy.nodeName !== 'HTML') {
                    noddy = noddy.parentNode;
                }
                if ('href' in noddy && this.href && noddy.href.indexOf('http') !== -1 && (noddy.href.indexOf(document.location.host) !== -1 || remotes)) {
                    event.preventDefault();
                    document.location.href = noddy.href;
                }
            }, false);
        }
    };

    const getSportSlug = () => sportSlug;

    const getSportWidgetSlug = () => sportWidgetSlug;

    const isSportPage = function () {
        const pathName = UrlService.getPathName();
        const sportSlug = getSportSlug();
        return pathName.startsWith(`/${sportSlug}/`);
    };

    const setIntervalForRefreshBalance = function () {
        if (isSportActive() && isSportPage()) {
            balanceInterval = setInterval(refreshBalance, 20000);
        }
    };

    const refreshBalance = function () {
        ng_fw.refreshBalance();
        $(document).trigger('balanceUpdated');
    };

    const stopBalanceInterval = function () {
        clearInterval(balanceInterval);
    };

    const isBrandDK = function () {
        return getDomainSuffixes() === 'dk';
    };

    /**
     * if player is logged out returns false, else returns a promise object
     * that contains how long the user is logged in
     * @returns {*}
     */
    const getLoginTimeDuration = function () {
        if (!Player.isLoggedIn()) return false;
        return Promise.all([Player.getLoginTimeStamp(),
            Player.getServerTimeStamp()]).then(function (values) {
            return timeDiff(new Date(values[0]), new Date(values[1]));
        }).catch(function (err) {
            console.error(err);
        });
    };

    /**
     * Private helper function that receives 2 Date objects, and retrieves the difference
     * @param start Date object
     * @param end Date object
     * @returns {{hours: number, minutes: number, seconds: number}}
     */
    const timeDiff = function (start, end) {
        // Fallback, in case end time (server timestamp)
        // is earlier than start time (Login timestamp)
        let localEnd = end;
        if (end < start) {
            localEnd = start;
        }
        // time in milliseconds
        const diff = localEnd.getTime() - start.getTime();
        const diffAsDate = new Date(diff);

        const hours = diffAsDate.getUTCHours();
        const minutes = diffAsDate.getMinutes();
        const seconds = diffAsDate.getSeconds();

        return { hours, minutes, seconds };
    };

    const dictionaryReady = function () {
        dictionaryRequest.resolve();
        $(document).trigger('dictionaryReady');
    };

    const partialsReady = function () {
        partialsRequest.resolve();
    };

    const stripHtml = function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || '';
    };

    const getPayNPlayData = function () {
        return AsgFW.getPayNPlayData();
    };

    /**
     * Returns German Panic button feature status (whether whole feature is active).
     * @returns {boolean}
     */
    const isGermanPanicButtonActive = function () {
        return AsgFW.getRbcSettings('germanyPanicButton') || true;
    };

    /**
     * Detects if there are all conditions to invoke a Panic button feature.
     * @returns {boolean}
     */
    const isPanicButtonRequired = function () {
        return AsgFW.getSessionDetails().CountryCode === 'DE' && isGermanPanicButtonActive();
    };

    /**
     * Returns German Panic button Lobby VIP level.
     * @returns {string}
     */
    const getGermanyPanicButtonLobbyVIPLevel = function () {
        const lobbyVIPLevel = AsgFW.getRbcSettings('germanyPanicButtonLobbyVIPLevel');
        return lobbyVIPLevel && !isNaN(parseInt(lobbyVIPLevel, 10)) ? lobbyVIPLevel : '1';
    };

    /**
     * Returns German Panic button InGame VIP level.
     * @returns {string}
     */
    const getGermanyPanicButtonInGameVIPLevel = function () {
        let inGameVIPLevel = AsgFW.getRbcSettings('germanyPanicButtonInGameVIPLevel');
        if (typeof inGameVIPLevel === 'object' && inGameVIPLevel !== null) {
            if (getPlatformName() === 'mobile' && Object.prototype.hasOwnProperty.call(inGameVIPLevel, 'mobile')) {
                inGameVIPLevel = inGameVIPLevel.mobile;
            } else if (getPlatformName() === 'desktop' && Object.prototype.hasOwnProperty.call(inGameVIPLevel, 'web')) {
                inGameVIPLevel = inGameVIPLevel.web;
            } else {
                inGameVIPLevel = '1';
            }
        }
        return inGameVIPLevel && !isNaN(parseInt(inGameVIPLevel, 10)) ? inGameVIPLevel : '1';
    };

    const isPlayerVerificationDeOn = function () {
        return AsgFW.getRbcSettings('verificationDE') || false;
    };

    /**
     * Get all promotions count (number).
     * @returns {string|*}
     */
    const getAllPromotionsNumber = function () {
        return asgData.allPromotionsNumber;
    };

    /**
     * Load extra scripts.
     */
    const loadExtraScripts = function () {
        if (window.AsgExtraScripts) {
            for (const src of Object.values(AsgExtraScripts)) {
                Tools.appendJS(src);
            }
            Tools.log('Extra scripts loaded. ', AsgExtraScripts);
        }
    };

    const loadAdScore = function () {
        if (asgData.adScoreUri) {
            Tools.appendJS(asgData.adScoreUri);
        }
    };

    const loadChatProvider = function () {
        document.dispatchEvent(new Event('readyForChatProvider'));
    };

    /**
     * Attach a delegated event to registration form (before element exists)
     */
    document.addEventListener('click', (e) => {
        if (
            e.target === document.querySelector('#mwc-app #registration-form #submitRegStep1')
            && document.querySelector('#mwc-app #registration-form.ng-valid')
        ) {
            document.dispatchEvent(new Event('registrationStep1Passed'));
        }
    });

    /**
     * Uncheck email bonus offers checkbox
     */
    document.addEventListener('registrationStep1Passed', () => {
        setTimeout(() => {
            if (AsgApp.isUkCountry()) {
                angular.element(document.querySelector('#mwc-app #registration-form')).scope().$apply((scope) => {
                    // eslint-disable-next-line no-param-reassign
                    scope.regModel.data.allowEmails = false;
                });
            }
        }, 500);
    });

    /*
       after logout remove class from body player-not-from-uk
     */
    $(document).on('LoggedOut', function () {
        jQuery('body').removeClass('player-not-from-uk');
    });

    $(document).on('LoggedIn', function () {
        // Add panic button feature for German players after login.
        if (isPanicButtonRequired()) {
            if (window.AsgSharedComponents) {
                const { fillConfig } = AsgSharedComponents.getActionCreators();

                AsgSharedComponents.dispatch(fillConfig({
                    isPanicButtonAvailable: true,
                }));
            }

            const hasPanicButton = Object.prototype.hasOwnProperty.call(AsgApp, 'panicButton');
            if (!hasPanicButton) {
                AsgApp.panicButton = {};
                AsgApp.panicButtonConfigs = {
                    GermanyPanicButtonLobbyVIPLevel: getGermanyPanicButtonLobbyVIPLevel(),
                    GermanyPanicButtonInGameVIPLevel: getGermanyPanicButtonInGameVIPLevel(),
                };

                // Get feature script.
                $.ajax(`${AsgApp.getFrameworkUri()}components/german-panic-button/german-panic-button.js`, {
                    dataType: 'script',
                    cache: true,
                });
            } else {
                AsgApp.panicButton.show();
            }
        }

        /**
         * after login add class to body  CountryCode + AsgFW.getSessionDetails().CountryCode
         *  if player not from UK add one more class player-not-from-uk
         * */
        const countryCode = AsgFW.getSessionDetails().CountryCode;
        jQuery('body').addClass(`CountryCode-${countryCode}`);
        if (countryCode !== 'GB') {
            jQuery('body').addClass('player-not-from-uk');
        }
    });

    /* Get into full screen */
    const goInFullscreenById = function (id) {
        const element = document.getElementById(id);
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
    };

    /* Get out of full screen */
    const goOutFullscreen = function () {
        if (document.exitFullscreen) {
            document.exitFullscreen().then().catch(() => {
                // do nothing
            });
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    };

    /* Is currently in full screen or not */
    const isFullScreenCurrently = function () {
        const fullScreenElement = document.fullscreenElement
            || document.webkitFullscreenElement
            || document.mozFullScreenElement
            || document.msFullscreenElement || null;
        return fullScreenElement === null;
    };

    /* add full screen change Listener */
    document.addEventListener('fullscreenchange', () => {
        if (!isFullScreenCurrently()) {
            document.body.classList.add('in-full-screen');
        } else {
            document.body.classList.remove('in-full-screen');
        }
    });

    const showVerificationStrip = function () {
        if (!isPlayerVerificationDeOn()) {
            Tools.log('PlayerVerification: not rendered - flag is OFF');
            return;
        }

        if (AsgFW.isDEregulation()) {
            AsgFW.getPlayerVerificationDetails(async (playerData) => {
                Tools.log('PlayerVerification: data received', playerData);

                if (!isVerificationDataAvailable(playerData)) {
                    return null;
                }

                await renderPlayerVerificationStripComponent({
                    verificationStatus: playerData.verificationStatus,
                    hoursLeft: playerData.timeToVerification,
                });

                // subscribe to live verification updates
                verificationUnsubscribeFn = AsgFW.onVerificationStatusUpdate(
                    async playerUpdatedData => {
                        Tools.log('PlayerVerification: status updated', playerUpdatedData);

                        if (!isVerificationDataAvailable(playerUpdatedData)) {
                            return null;
                        }

                        await renderPlayerVerificationStripComponent({
                            verificationStatus: playerUpdatedData.verificationStatus,
                            hoursLeft: playerUpdatedData.timeToVerification,
                        });
                    },
                );
            });
        } else {
            Tools.log('PlayerVerification: not rendered - not DE region');
        }

        function isVerificationDataAvailable(data) {
            return data && data.verificationStatus;
        }
    };

    const renderPlayerVerificationStripComponent = async function (options) {
        try {
            if (!window.AsgPlayerVerification) {
                await loadVerificationStripComponent();
            }

            window.AsgPlayerVerification.renderStrip(
                document.getElementById('player-verification-strip-wrap'),
                {
                    verificationStatus: options.verificationStatus,
                    hoursLeft: options.hoursLeft,
                },
            );

            Tools.log('PlayerVerification: Verification strip rendered');
        } catch (e) {
            Tools.log(`PlayerVerification: Error ${e.message}`);
        }
    };

    const destroyVerificationStrip = function () {
        if (window.AsgPlayerVerification) {
            window.AsgPlayerVerification.destroyStrip(
                document.getElementById('player-verification-strip-wrap'),
            );
        }

        unsubscribeFromVerificationUpdates();
    };

    const unsubscribeFromVerificationUpdates = function () {
        if (verificationUnsubscribeFn && verificationUnsubscribeFn()) {
            Tools.log('PlayerVerification: Unsubscribed from verification data');
        }
    };

    const loadVerificationStripComponent = async function () {
        $('body').append('<div id="player-verification-strip-wrap"></div>');
        Tools.appendCss(`${getFrameworkUri()}components/player_verification_de/dist/asg-player-verification.min.js.css`);
        await Tools.appendJSAsync(`${getFrameworkUri()}components/player_verification_de/dist/asg-player-verification.min.js`);
        Tools.log('PlayerVerification: Verification script loaded');
    };

    const showSmartFooter = async () => {
        const el = document.getElementById('smart-footer');
        if (!el) {
            throw new Error('#smart-footer container not found');
        }

        const { host } = new URL(location.href);
        const playerRegulation = AsgFW.getRegulation();
        const playerCountry = AsgFW.getCurrentCountry().toUpperCase();

        el.innerHTML = await AsgFW.getSmartFooterHTML(
            host,
            playerCountry,
            playerRegulation,
            AsgFW.SmartFooterIconsSizeModesEnum.RESIZED_REGULATIONS,
        );
    };

    const showCopyright = async () => {
        const el = document.getElementById('asg-copyright-text');
        const host = Tools.capitalize(AsgFW.getBrandDomain());
        const playerRegulation = AsgFW.getRegulation();
        const playerCountry = AsgFW.getCurrentCountry().toUpperCase();

        try {
            const { data: { copyrightText } } = await AsgFW.getCopyright({
                language: AsgFW.getLanguage(),
                host,
                countryCode: playerCountry,
                regulation: playerRegulation,
            });

            el.innerHTML = copyrightText;
        } catch (e) {
            Tools.log('Failed to retrieve copyright text');
        }
    };

    const getStatusBarPage = () => {
        switch (true) {
        case isSportPage():
            return 'sportPage';
        case InGame.isInGame():
            return 'gamePage';
        case currentPageTemplate === 'page.php':
        case currentPageTemplate === 'template-home.php':
        case currentPageTemplate === 'template-lobby.php':
            return 'lobbyPage';
        default:
            return '';
        }
    };

    const isGamePageTemplate = () => currentPageTemplate === 'game-page.php';
    const isGamesListPageTemplate = () => currentPageTemplate === 'games-page.php';
    const isCasinoPageTemplate = () => currentPageTemplate === 'page.php';
    const isSportPageTemplate = () => currentPageTemplate === 'sport-page.php';
    const isVerticalPage = () => (isCasinoPageTemplate() || isSportPageTemplate());

    const redirectToLobby = () => {
        window.location.href = '/';
    };

    const getSlugFromString = (string) => string.trim().replace(/[ ]/g, '-').toLowerCase();

    const getMobileOsType = () => mobileOsType;

    /*
     * New verticals/categories management methods.
     */
    const getPlatformName = () => (AsgFW.isMobilePamPlatform() ? 'mobile' : 'desktop');

    const getDefaultVerticalsMenu = () => ({
        mobile: [],
        desktop: [],
    });

    const prepareVerticalsMenu = (verticalsMenuParam, platformName) => {
        const verticalsMenuData = verticalsMenuParam?.[platformName] ?? null;
        const verticalsMenu = getVerticalsMenu(verticalsMenuData);

        return verticalsMenu || getDefaultVerticalsMenu();
    };

    const groupVerticalsMenu = (verticalsMenu) => {
        const byLocation = {};
        const byId = {};
        const byType = {};

        Object.entries(verticalsMenu).forEach(([p, verticalsForPlatform]) => {
            byLocation[p] = {};
            byId[p] = {};
            byType[p] = {};

            verticalsForPlatform.forEach((v) => {
                const { location: l, id, type: t } = v;

                if (Array.isArray(byLocation[p][l])) {
                    byLocation[p][l].push(v);
                } else {
                    byLocation[p][l] = [v];
                }

                byId[p][id] = v;

                if (Array.isArray(byType[p][t])) {
                    byType[p][t].push(v);
                } else {
                    byType[p][t] = [v];
                }
            });
        });

        return {
            byLocation,
            byId,
            byType,
        };
    };

    const getVerticalIdByStoredId = (pathName, platformName) => {
        const storedVerticalId = JSON.parse(Cookie.read(cookieNames.CURRENT_VERTICAL_ID));
        const storedVerticalIdByPath = storedVerticalId?.[pathName];

        return storedVerticalIdByPath && verticals.byId[platformName][storedVerticalIdByPath]
            ? storedVerticalIdByPath
            : null;
    };

    const getVerticalIdByStoredType = (pathName, platformName) => {
        const storedVerticalType = JSON.parse(Cookie.read(cookieNames.CURRENT_VERTICAL_TYPE));
        const storedVerticalTypeByPath = storedVerticalType?.[pathName];
        const verticalsByType = storedVerticalTypeByPath
            && verticals.byType?.[platformName]?.[storedVerticalTypeByPath];

        return (verticalsByType?.length && verticalsByType[0].id) || null;
    };

    const prepareVerticals = (verticalsMenuParam) => {
        const p = getPlatformName();

        // Prepare verticals data.
        const verticalsMenu = prepareVerticalsMenu(verticalsMenuParam, p);
        const { byLocation, byId, byType } = groupVerticalsMenu(verticalsMenu);

        verticals.byOrder = verticalsMenu;
        verticals.byLocation = byLocation;
        verticals.byId = byId;
        verticals.byType = byType;

        const pathName = UrlService.getPathName();

        // Set current vertical from storage or default
        const currentVerticalId = getVerticalIdByStoredId(pathName, p)
            || getVerticalIdByStoredType(pathName, p)
            || getDefaultVerticalId(pathName);
        if (currentVerticalId) {
            setCurrentVerticalId(currentVerticalId, pathName);
        }

        // Prepare default Category Set.
        let defaultCategorySet;
        if (verticals.byLocation[p][pathName]) {
            defaultCategorySet = {
                categoryId: verticals.byLocation[p][pathName][0].categoryId,
                subCategoryId: verticals.byLocation[p][pathName][0].subCategoryId,
            };
        } else if (currentPageTemplate === 'page.php' && verticals.byOrder[p][0] && verticals.byOrder[p][0].type === 'casino') {
            defaultCategorySet = {
                categoryId: verticals.byOrder[p][0].categoryId,
                subCategoryId: verticals.byOrder[p][0].subCategoryId,
            };
        }

        if (window.AsgSharedComponents) {
            const {
                fillVerticals,
                setAreFavoritesEnabled,
            } = AsgSharedComponents.getActionCreators();
            AsgSharedComponents.dispatch(fillVerticals({
                byOrder: verticals.byOrder[p],
                byId: verticals.byId[p],
            }));
            AsgSharedComponents.dispatch(setAreFavoritesEnabled(
                hasFavoritesInVerticals(),
            ));
        }

        // Update current Category Set.
        const storedCategorySet = JSON.parse(localStorage.getItem('currentCategorySet'));
        const currentCategorySet = storedCategorySet && storedCategorySet[pathName]
            ? storedCategorySet[pathName] : defaultCategorySet;
        if (currentCategorySet) {
            setCurrentCategorySet(currentCategorySet);
        }

        setSingleVerticalClass();

        // Emit 'verticalsReady' event.
        $(document).trigger('verticalsReady');
        document.body.classList.add('verticals-rendered');
    };

    /**
     * Set or remove body class for 1 vertical only
     */
    const setSingleVerticalClass = () => {
        const platform = getPlatformName();
        const verticalsByorder = getVerticals().byOrder[platform];
        const singleVerticalClass = 'single-vertical';

        if (Array.isArray(verticalsByorder) && verticalsByorder.length === 1) {
            document.body.classList.add(singleVerticalClass);
        } else {
            document.body.classList.remove(singleVerticalClass);
        }
    };

    const hasFavoritesInVerticals = () => {
        let result = false;
        if (AsgFW.isLoggedIn() || AsgFW.isLoggedInByCookie()) {
            const platform = getPlatformName();
            const verticals = getVerticals().byOrder[platform];
            const verticalTypesWithChildren = casinoLikeVerticals;
            const verticalTypesWithActionData = [verticalTypesEnum.RECOMMENDATIONS];
            const hasFavoritesInChildren = verticals
                .filter(vertical => verticalTypesWithChildren.includes(vertical.type))
                .some(vertical => vertical.children && vertical.children
                    .some(child => child.action === verticalActionTypesEnum.FAVORITES_CATEGORY));
            const hasFavoritesInActionData = verticals
                .filter(vertical => verticalTypesWithActionData.includes(vertical.type))
                .some(vertical => vertical.categoriesOrder && vertical.categoriesOrder
                    .includes(verticalActionTypesEnum.FAVORITES_CATEGORY));
            result = hasFavoritesInChildren || hasFavoritesInActionData;
        }
        return result;
    };

    /**
     * Get default vertical id
     * @param pathname
     * @returns {number|null}
     */
    const getDefaultVerticalId = (pathname) => {
        const p = getPlatformName();
        const { hash } = location;
        const verticalsByOrder = verticals.byOrder[p].filter(filterNotDefaultVertical);
        const verticalByAltLocation = verticalsByOrder.find((v) => v.altLocation === pathname);
        const verticalByLocationWithHash = verticalsByOrder.find((v) => v.location === `${pathname}${hash}`);
        const sportWidgetSlug = getSportWidgetSlug();

        // Prepare default verticalId.
        let defaultVerticalId = null;

        if (verticalByAltLocation) {
            // mark vertical by altLocation
            defaultVerticalId = verticalByAltLocation.id;
        } else if (verticalByLocationWithHash) {
            // mark vertical by location searched with hash
            defaultVerticalId = verticalByLocationWithHash.id;
        } else if (verticals.byLocation[p][pathname]) {
            // mark vertical by location
            const verticalsByLocation = verticals.byLocation[p][pathname]
                .filter(filterNotDefaultVertical);
            defaultVerticalId = verticalsByLocation[0].id;
        } else if (pathname.includes(sportWidgetSlug)) {
            // Mark sport vertical if sport widget links.
            const sportVertical = verticalsByOrder.find(v => v.type === verticalTypesEnum.SPORT);
            defaultVerticalId = sportVertical?.id || defaultVerticalId;
        } else if (isVerticalPage()) {
            const defaultVertical = verticalsByOrder.find(v => v.isDefault);
            defaultVerticalId = defaultVertical
                ? defaultVertical.id
                : verticalsByOrder[0].id;
        }
        return defaultVerticalId;
    };

    // eslint-disable-next-line max-len
    const filterNotDefaultVertical = v => v.action !== verticalActionTypesEnum.RECOMMENDATIONS_CATEGORY;

    const setVerticalsEventHandlers = () => {
        const sessionStatusHandler = () => {
            callVerticalsMenuApi().then(
                (menu, games) => {
                    const verticalsMenu = {
                        mobile: [],
                        desktop: [],
                    };
                    const p = getPlatformName();
                    verticalsMenu[p] = menu;
                    prepareVerticals(verticalsMenu);
                    Games.updateVerticalsInStore();

                    if (isNeoCmsIntegrationEnabled() && games) {
                        Games.processCmsGames(games);
                    }
                },
            );
        };
        document.addEventListener('justLoggedIn', sessionStatusHandler);
        document.addEventListener('justLoggedOut', sessionStatusHandler);
        document.addEventListener('LoggedInByCookieChanged', sessionStatusHandler);
    };

    const getVerticalsMenu = (verticalsMenuRaw) => {
        if (!backendVerticalsMenu && !verticalsMenuRaw) {
            return null;
        }

        const menu = verticalsMenuRaw || backendVerticalsMenu;
        const menusPrepared = [];

        Object.keys(menu).forEach((menuId) => {
            const menuItemData = menu[menuId];
            const actionMap = {
                asgCoreCategory: 'ng',
                openLink: 'externalLink',
            };
            const menuItem = {
                id: menuItemData.id,
                type: menuItemData.verticalType,
                location: menuItemData.location,
                altLocation: menuItemData.altLocation || null,
                icon: menuItemData.icon,
                name: menuItemData.text,
                action: menuItemData.action in actionMap
                    ? actionMap[menuItemData.action] : menuItemData.action,
                target: menuItemData.action === 'openLink' ? menuItemData.actionData : null,
                children: menuItemData.children,
                defaultChildId: menuItemData.defaultChildId,
                isSameLocation: window.location.pathname === menuItemData.location,
                isDefault: menuItemData.isDefault,
            };

            if (menuItem.action === 'ng') {
                menuItem.categoryId = menuItemData.actionData.categoryId;
                menuItem.subCategoryId = menuItemData.actionData.subCategoryId;
            }
            if (menuItem.action === verticalActionTypesEnum.RECOMMENDATIONS_CATEGORY) {
                menuItem.categoriesOrder = menuItemData.actionData?.categoriesOrder || [];
            }
            menusPrepared.push(menuItem);
        });

        return { mobile: menusPrepared, desktop: menusPrepared };
    };

    const callVerticalsMenuApi = () => (new Promise((resolve) => {
        const { regulation, brand, country } = AsgFW.getRBC();
        SolarAPI.get(
            '/api/v1/verticals-menu',
            {
                sso: AsgFW.isLoggedIn() ? 1 : 0,
                regulation,
                casinoId: brand,
                country,
                language: AsgFW.getLanguage(),
                platformId: AsgFW.getPlatformId(),
                currencyCode: AsgFW.getCurrency(),
            },
            (solarResponse) => {
                const { data: { menu, games } } = solarResponse;
                resolve(menu, games);
            },
        );
    }));

    const setCurrentVerticalId = (verticalId, targetPathname = undefined) => {
        setCurrentVerticalIdCookie(verticalId, targetPathname);

        if (window.AsgSharedComponents) {
            const { setCurrentVertical } = AsgSharedComponents.getActionCreators();
            AsgSharedComponents.dispatch(setCurrentVertical(verticalId));
        }
    };

    const storeCurrentVerticalIdToCookie = (verticalId, pathname) => {
        // cvi stands for "Current Vertical Id"
        const { CURRENT_VERTICAL_ID } = cookieNames;
        const cviCookieValue = JSON.parse(Cookie.read(CURRENT_VERTICAL_ID)) || {};
        const cviCookieValueNew = {
            ...cviCookieValue,
            [pathname]: verticalId,
        };
        Cookie.create(CURRENT_VERTICAL_ID, JSON.stringify(cviCookieValueNew), '180', '/');
    };

    const storeCurrentVerticalTypeToCookie = (verticalId, pathname) => {
        // cvt stands for "Current Vertical Type"
        const verticalType = verticals?.byId?.[getPlatformName()]?.[verticalId]?.type;
        if (verticalType) {
            const { CURRENT_VERTICAL_TYPE } = cookieNames;
            const cvtCookieValue = JSON.parse(Cookie.read(CURRENT_VERTICAL_TYPE)) || {};
            const cvtCookieValueNew = {
                ...cvtCookieValue,
                [pathname]: verticalType,
            };
            Cookie.create(CURRENT_VERTICAL_TYPE, JSON.stringify(cvtCookieValueNew), '180', '/');
        }
    };

    const setCurrentVerticalIdCookie = (verticalId, targetPathname = undefined) => {
        const prevVertical = AsgApp.getCurrentVertical();
        verticals.prevVerticalId = prevVertical ? prevVertical.id : verticals.prevVerticalId;
        verticals.currentVerticalId = verticalId;
        const pathname = targetPathname || UrlService.getPathName();

        storeCurrentVerticalIdToCookie(verticalId, pathname);
        storeCurrentVerticalTypeToCookie(verticalId, pathname);
    };

    const getVerticals = () => verticals;

    const getCurrentVertical = () => {
        const p = getPlatformName();
        return verticals.byId[p][verticals.currentVerticalId];
    };

    const setCurrentCategorySet = (categorySet, targetPathname = undefined) => {
        verticals.currentCategoryId = categorySet.categoryId;
        verticals.currentSubCategoryId = categorySet.subCategoryId;
        const pathname = targetPathname || UrlService.getPathName();
        const lsValue = JSON.parse(localStorage.getItem('currentCategorySet')) || {};
        const lsValueNew = {
            ...lsValue,
            [pathname]: categorySet,
        };
        localStorage.setItem('currentCategorySet', JSON.stringify(lsValueNew));
    };

    const getCurrentCategorySet = () => ({
        categoryId: parseInt(verticals.currentCategoryId, 10),
        subCategoryId: parseInt(verticals.currentSubCategoryId, 10),
    });

    const openFirstVertical = (e) => {
        const targetPathName = e?.currentTarget?.pathname;
        const currentPathName = UrlService.getPathName();
        if (
            // work as normal <a> if target URL is different
            (targetPathName !== currentPathName)
            // work as normal <a> if target URL is same and on sport
            || (targetPathName === currentPathName && isSportPage())
        ) {
            return;
        }

        if (e) {
            e.preventDefault();
        }

        const platform = getPlatformName();
        const {
            id,
            location,
            name,
            categoryId,
            subCategoryId,
        } = getVerticals().byOrder[platform][0];

        AsgUI.NewHeader.changeVerticalInUI({
            verticalId: id,
            verticalLocation: location,
            categoryId,
            subCategoryId,
            verticalName: name,
        });
    };

    const exitGameMessageCheck = () => {
        if (AsgFW.isMobilePamPlatform()
            && Player.isLoggedIn()
            && ExitGameMessage) {
            const params = new URLSearchParams(location.search);
            if (params.get('NeoDL') === 'ForceEGPS' && params.get('PlayMode') === 'M') {
                InGame.setLastPlayedGameId(params.get('GID'));
                ExitGameMessage.isNeedToShow = true;
                ExitGameMessage.show();
            }
        }
    };

    const isLoyaltyAvailable = () => (!AsgFW.getRbcSettings('hideLoyaltyPageFlag'));

    const getBalanceFoldData = () => {
        if (!AsgFW.isLoggedIn()) {
            return null;
        }

        const balance = AsgFW.getDisplayBalance();

        if (isCasinoVertical() && isSportActive()) {
            return [
                {
                    title: Dictionary.translate('balance'),
                    number: balance.DisplayBalance,
                    main: true,
                },
                {
                    title: Dictionary.translate('moneyBalance'),
                    number: balance.DisplayRealBalance,
                },
                {
                    title: Dictionary.translate('bonus_2'),
                    number: balance.DisplayBonusBalance,
                },
            ];
        }

        if (isCasinoVertical() && !isSportActive()) {
            return [
                {
                    title: Dictionary.translate('balance'),
                    number: balance.DisplayBalance,
                    main: true,
                },
                {
                    title: Dictionary.translate('bonus_2'),
                    number: balance.DisplayBonusBalance,
                },
            ];
        }

        if (isSportVertical() && AsgFW.getRegulation() !== 'GB') {
            const resultBalanceConfig = [
                {
                    title: Dictionary.translate('moneyBalance'),
                    number: balance.DisplayRealBalance,
                    main: true,
                },
            ];

            if (parseInt(balance.BonusBalance, 10) > 0) {
                resultBalanceConfig.push({
                    title: Dictionary.translate('bonus_2'),
                    number: balance.DisplayBonusBalance,
                });
            }

            return resultBalanceConfig;
        }

        if (isSportVertical() && AsgFW.getRegulation() === 'GB') {
            const resultBalanceConfig = [
                {
                    title: Dictionary.translate('moneyBalance'),
                    number: balance.DisplayRealBalance,
                    main: true,
                },
            ];

            if (parseInt(balance.BonusBalance, 10) > 0) {
                resultBalanceConfig.push({
                    title: Dictionary.translate('casinoBonus'),
                    number: balance.DisplayBonusBalance,
                });
            }

            return resultBalanceConfig;
        }

        return null;
    };

    /**
     * Returns true if only one vertical of specified type is configured for brand
     */
    const isSingleVerticalTypeBrand = (verticalTypeToCheck) => {
        const verticals = getVerticals();
        const verticalsPlatformKey = getPlatformName();

        return verticals.byOrder
              && verticals.byOrder[verticalsPlatformKey]
              && verticals.byOrder[verticalsPlatformKey].length === 1
              && verticals.byOrder[verticalsPlatformKey][0].type === verticalTypeToCheck;
    };

    /**
     * Get default location from vertical by platform and type
     * @param {string} verticalType
     * @return {string|null}
     */
    const getDefaultLocationForVerticalType = (verticalType) => {
        const verticalsMenu = getVerticals();
        const verticalsPlatformKey = getPlatformName();
        const filteredVerticals = verticalsMenu.byOrder[verticalsPlatformKey]
            ? verticalsMenu.byOrder[verticalsPlatformKey].filter(i => i.type === verticalType)
            : [];
        return filteredVerticals.length && filteredVerticals[0]
            ? filteredVerticals[0].location
            : null;
    };

    const isNeoCmsIntegrationEnabled = () => neoCmsIntegration;

    const setAppStateToStore = () => {
        if (window.AsgSharedComponents) {
            const {
                regulation,
                brand,
                country,
            } = AsgFW.getRBC();

            const {
                handlePlatformReady,
                setRbc,
                setRbcSettings,
                setBrandName,
            } = AsgSharedComponents.getActionCreators();

            AsgSharedComponents.dispatch(setRbc({
                regulation,
                casinoId: brand,
                countryCode: country,
            }));

            AsgSharedComponents.dispatch(setRbcSettings({
                isHideLoyaltyPageFlag: AsgFW.getRbcSettings('hideLoyaltyPageFlag'),
                isPromotionsAvailable: AsgFW.getRbcSettings('isPromotionsAvailable'),
                shouldShowLastLogin: AsgFW.getRbcSettings('showLastLogin'),
            }));

            Player.setPlayerBalanceToStore();
            AsgSharedComponents.dispatch(handlePlatformReady(true));

            AsgSharedComponents.dispatch(setBrandName(AsgFW.getBrandName()));
        }
    };

    const setConfigToStore = () => {
        if (window.AsgSharedComponents) {
            const {
                fillConfig,
                fillLanguage,
                fillPlatformStatus,
                fillBannersPlaceholderData,
                fillSportLoaderIcons,
                setIsLoggedIn,
                setLastLoginTimeStamp,
                setIsRegistered,
                fillShowBingoBanners,
                fillShowSportBanners,
                fillSportBannersPlaceholderData,
                fillBackendPageTemplate,
                setIsNeoCmsIntegrationEnabled,
            } = AsgSharedComponents.getActionCreators();

            AsgSharedComponents.dispatch(fillLanguage({
                iso2: languageIso2,
                iso3: lng,
                wpml: wpmlLanguage,
            }));

            AsgSharedComponents.dispatch(fillConfig({
                ajaxUri: getAjaxUri(),
                logoImageData,
                PayNPlay,
                isNativeApp,
                isNativeSsoApp,
                mobileOsType,
                languageSwitcherData,
            }));

            AsgSharedComponents.dispatch(fillBackendPageTemplate(currentPageTemplate));

            document.addEventListener('asgRbcSettingsReady', () => {
                AsgSharedComponents.dispatch(fillConfig({
                    frameworkUri: getFrameworkUri(),
                    templateDirectoryUri,
                    isPayNPlayEnabled: isPayNPlayEnabled(),
                    intJackpotsBasic: AsgFW.getRbcSettings('intJackpotsBasic'),
                    intJackpotsPremium: AsgFW.getRbcSettings('intJackpotsPremium'),
                    newGamePage: AsgFW.getRbcSettings('newGamePage'),
                    newGamePageExcludedVendors: AsgFW.getRbcSettings('newGamePageExcludedVendors'),
                    newGamePageExcludedVendorsMobile: AsgFW.getRbcSettings('newGamePageExcludedVendorsMobile'),
                    showWinnerTicker: AsgFW.getRbcSettings('showWinnerTicker'),
                    showStripsGridUI: AsgFW.getRbcSettings('showStripsGridUI'),
                    winnersStripConfig: AsgFW.getRbcSettings('winnersStripConfig'),
                }));
            });

            const sessionStatusHandler = (isLoggedIn) => {
                AsgSharedComponents.dispatch(setIsLoggedIn(isLoggedIn));
                AsgSharedComponents.dispatch(setLastLoginTimeStamp(Player.getLastLoginTimeStamp()));
            };
            sessionStatusHandler(AsgFW.isLoggedIn() || AsgFW.isLoggedInByCookie());
            document.addEventListener('LoggedIn', sessionStatusHandler.bind(null, true));
            document.addEventListener('LoggedOut', sessionStatusHandler.bind(null, false));

            AsgSharedComponents.dispatch(setIsRegistered(AsgFW.isRegistered()));

            AsgSharedComponents.dispatch(fillPlatformStatus({
                isMobile: AsgFW.isMobilePamPlatform(),
                platformId: AsgFW.getPlatformId(),
            }));
            AsgSharedComponents.dispatch(
                fillBannersPlaceholderData(placeholderBannerData),
            );
            AsgSharedComponents.dispatch(
                fillShowBingoBanners(showBingoBannerData && showBingoBannerData.active),
            );
            AsgSharedComponents.dispatch(fillSportLoaderIcons(sportLoaderIcons));
            AsgSharedComponents.dispatch(
                fillShowSportBanners(sportMainBannerData && sportMainBannerData.active),
            );
            const placeholder = sportMainBannerData && sportMainBannerData.placeholder;
            AsgSharedComponents.dispatch(fillSportBannersPlaceholderData(placeholder));
            AsgSharedComponents.dispatch(setIsNeoCmsIntegrationEnabled(
                isNeoCmsIntegrationEnabled(),
            ));
        }
    };

    const setIsSearchEnabledToStore = () => {
        if (window.AsgSharedComponents) {
            const {
                setIsSearchEnabledOnVertical,
            } = AsgSharedComponents.getActionCreators();
            AsgSharedComponents.dispatch(setIsSearchEnabledOnVertical(getIsSearchEnabled()));
        }
    };

    /**
     * Check login by cookie change
     * Will be logged in by cookie before asg ready, after this status could change
     */
    const setLoggedInByCookieHandler = () => {
        isLoggedInByCookie = AsgFW.isLoggedInByCookie();
        const sessionStatusHandler = (isLoggedIn) => {
            if (isLoggedInByCookie !== isLoggedIn) {
                document.dispatchEvent(new Event('LoggedInByCookieChanged'));
            }
        };
        document.addEventListener('LoggedIn', sessionStatusHandler.bind(null, true));
        document.addEventListener('LoggedOut', sessionStatusHandler.bind(null, false));
    };

    /**
     * This is a fallback for backend 'lng' cookie logic
     * In case backend didn't process lng cookie (due to page cache for example)
     * - set correct cookie on front-end
     */
    const setLangCookie = () => {
        const lngQuery = (new URLSearchParams(window.location.search)).get('lng');
        if (lngQuery && lngQuery !== Cookie.read('lng')) {
            Cookie.create('lng', lng, 180, '/');
            Cookie.create('l', languageIso2, 180, '/');
        }
    };

    const getIsSearchEnabled = () => (Object.prototype.hasOwnProperty.call(asgData, 'isSearchEnabled')
        ? asgData.isSearchEnabled
        : false);

    const getPlaceholderBannerData = () => placeholderBannerData;

    const subscribeForBannersUpdates = () => {
        if (window.AsgSharedComponents) {
            const {
                fillCasinoBanners,
                fillLiveCasinoBanners,
                fillBingoBanners,
                fillSportBanners,
            } = AsgSharedComponents.getActionCreators();

            const addBannersToStore = () => {
                const casinoBanners = AsgFW.getAspireEngageBanners(
                    AsgFW.getBannersCarouselTypes().Casino,
                    getUnsegmentedBanners(),
                    1,
                    AsgFW.isPayNPlayAvailable(),
                    AsgFW.getCurrency(),
                );

                const liveCasinoBanners = AsgFW.getAspireEngageBanners(
                    AsgFW.getBannersCarouselTypes().LiveCasino,
                    getUnsegmentedBanners(),
                    1,
                    AsgFW.isPayNPlayAvailable(),
                    AsgFW.getCurrency(),
                );

                const bingoBanners = AsgFW.getAspireEngageBanners(
                    AsgFW.getBannersCarouselTypes().Bingo,
                    [],
                    1,
                    AsgFW.isPayNPlayAvailable(),
                    AsgFW.getCurrency(),
                );

                const sportBanners = AsgFW.getAspireEngageBanners(
                    AsgFW.getBannersCarouselTypes().Sport,
                    [],
                    5,
                    AsgFW.isPayNPlayAvailable(),
                    AsgFW.getCurrency(),
                );

                // if NG is still loading and looks like player was logged in
                // - do not render unsegmented banners, keep loader
                if (!AsgFW.isLoggedIn() && Cookie.read(AsgFW.CookieNames.PLAYER_NG_STATUS)) {
                    Tools.log('Banners: render skipped -  whait for segmented/engage banners');
                    return null;
                }

                const { app, bingo, sport } = AsgSharedComponents.getState();

                // render banners only in case they changed
                if (!compareBannersList(app.casinoBanners.bannersList, casinoBanners)) {
                    AsgSharedComponents.dispatch(fillCasinoBanners(casinoBanners));
                }
                if (!compareBannersList(app.liveCasinoBanners.bannersList, liveCasinoBanners)) {
                    AsgSharedComponents.dispatch(fillLiveCasinoBanners(liveCasinoBanners));
                }
                // set bingo banners to store
                if (!compareBannersList(bingo.bingoBanners, bingoBanners)) {
                    AsgSharedComponents.dispatch(fillBingoBanners(bingoBanners));
                }
                // set sport banners to store
                if (!compareBannersList(sport.banners.bannersList, sportBanners)) {
                    AsgSharedComponents.dispatch(fillSportBanners(sportBanners));
                }
            };

            // set unsegmented banners to store
            addBannersToStore();

            document.addEventListener('ASGSegmentedBannersReady', addBannersToStore);
            document.addEventListener('AspireEngageBannersData', addBannersToStore);
            document.addEventListener('ASGBannersReady', addBannersToStore);
        }
    };

    const compareBannersList = (a, b) => Tools.compareObjects(a, b);

    const getSegmentedBanners = () => (AsgFW.isMobilePamPlatform()
        ? AsgApp.getBannersMobile()
        : AsgApp.getBannersWeb());

    const getUnsegmentedBanners = () => (
        mapUnsegmentedBanners(unsegmentedBanners, getTnCforUnsegmentedBanners()));

    const getTnCforUnsegmentedBanners = () => {
        const regulationTextWp = asgData.regulationText;
        let terms = Dictionary.translate('RegulationTermsPreLogin');
        if (regulationTextWp) {
            if (hasSpecificRegulationText()
                || isUkCountry()
                || AsgFW.getDetectedRegulation() === 'MGA'
            ) {
                terms = regulationTextWp;
            }
            if (isBrandDK()) {
                terms = `${regulationTextWp} ${terms}`;
            }
        }
        return terms;
    };

    /**
     * Change structure from WP. Prepare for AsgFW using
     * @param {Object[]} banners
     * @return {Object[]}
     */
    const mapUnsegmentedBanners = (banners, TnC = '') => {
        if (!Array.isArray(banners)) {
            return [];
        }

        return banners.map(b => ({
            actions: {
                banner: {
                    type: 0,
                    ActionID: '',
                },
                CTA: {
                    type: 0,
                    ActionID: '',
                },
                TnC: {
                    type: 0,
                    ActionID: '',
                },
            },
            content: {
                image: b.url || b.Source,
                title: '',
                subtitle: '',
                CTAtext: '',
                TnC,
            },
        }));
    };

    const getPrioritizedGames = () => {
        if (isNeoCmsIntegrationEnabled()) {
            return;
        }

        SolarAPI.get(
            '/api/v2/brands/{casinoId}/games/prioritized',
            {
                country: AsgFW.getCurrentCountry(),
                verticalId: 0,
            },
            (prioritizedGamesResponse) => {
                if (prioritizedGamesResponse.error || !prioritizedGamesResponse.data.games) {
                    throw new Error('Failed to fetch prioritized games');
                }

                if (Array.isArray(prioritizedGamesResponse.data.games)
                    && !prioritizedGamesResponse.data.games.length) {
                    return null;
                }

                const gamesByVertical = prioritizedGamesResponse.data.games;
                const prioritizedGamesWithImages = {};

                Object.keys(gamesByVertical).forEach((verticalId) => {
                    const prioritizedGames = gamesByVertical[verticalId];
                    const verticalCode = solarVerticalIdsEnum[verticalId];
                    AsgUI.populatePreloadImages(prioritizedGames);

                    prioritizedGamesWithImages[verticalCode] = prioritizedGames;
                });

                // put preload games into featured games subcategories
                updatePrioritizedGamesInStore(prioritizedGamesWithImages);
            },
        );
    };

    const renderLtPromotions = () => {
        if (window.AsgPromotionsComponents
            && window.AsgSharedComponents
            && isLtPromotionsEnabled()
            && isPromotionsPage()
        ) {
            AsgPromotionsComponents.renderLtPromotionsList({
                element: document.getElementById('asg-promotions-fold'),
            });
        }
    };

    const renderEmbeddedGame = () => {
        if (window.AsgVerticals && AsgFW.getRbcSettings('newGamePage')) {
            AsgVerticals.renderEmbeddedGame({
                element: document.getElementById('embedded-game-container'),
            });
        }
    };

    const isPromotionsPage = () => ['/promotions/', '/promotions'].includes(window.location.pathname);
    const isPromotionPage = () => !isPromotionsPage() && window.location.pathname.indexOf('/promotions/') !== -1;

    const updatePrioritizedGamesInStore = (prioritizedGamesWithImages) => {
        if (window.AsgSharedComponents) {
            const { app: { verticals } } = AsgSharedComponents.getState();

            // go over verticals, find virtual featured games subcategories
            // put relevant game ids into virtual subcategories and update redux
            const updatedVerticals = verticals.map((vertical) => {
                let verticalChildren = vertical.children;

                if (
                    vertical.children
                    && casinoLikeVerticals.includes(vertical.type)
                ) {
                    const verticalCode = vertical.type;
                    verticalChildren = vertical.children.map((subcategory) => {
                        let gameIds = subcategory.gameIds || [];

                        if ([verticalActionTypesEnum.FEATURED_GAMES,
                            verticalActionTypesEnum.FAVORITES_CATEGORY].includes(subcategory.action)
                        ) {
                            gameIds = prioritizedGamesWithImages[verticalCode]
                                .map((prioritizedGame) => (+prioritizedGame.id));
                        }

                        // make a shallow clone so redux will apply changes
                        return {
                            ...subcategory,
                            gameIds,
                        };
                    });
                }

                // make a shallow clone so redux will apply changes
                return {
                    ...vertical,
                    children: verticalChildren,
                };
            });

            const { fillPrioritizedGames, fillVerticals } = AsgSharedComponents.getActionCreators();
            AsgSharedComponents.dispatch(fillPrioritizedGames(prioritizedGamesWithImages));
            AsgSharedComponents.dispatch(fillVerticals({
                byOrder: updatedVerticals,
            }));
        }
    };

    const applyPlatformDeepLinks = () => {
        if (window.AsgSharedComponents) {
            AsgSharedComponents.services.DeepLinksService.applyPlatformDeepLinks({
                dispatch: AsgSharedComponents.getDispatch(),
                actions: AsgSharedComponents.getActionCreators(),
                state: AsgSharedComponents.getState(),
            });
        }
    };

    const isEmbeddedGamePageEnabled = (gameId) => {
        if (AsgFW.getRbcSettings('newGamePage') && window.AsgSharedComponents) {
            const { EmbeddedGameService } = AsgSharedComponents.services;
            const state = AsgSharedComponents.getState();
            const {
                config: {
                    newGamePage,
                    newGamePageExcludedVendors,
                    newGamePageExcludedVendorsMobile,
                },
                isMobile,
            } = state.app;
            const { gamesById } = state.casino;
            const { isLoggedIn } = state.player;

            const detectedExcludedVendors = isMobile
                ? newGamePageExcludedVendorsMobile
                : newGamePageExcludedVendors;

            return EmbeddedGameService.isFeatureEnabledForGame({
                flags: {
                    newGamePage,
                    newGamePageExcludedVendors: detectedExcludedVendors,
                    isLoggedIn,
                },
                game: gamesById[gameId],
            });
        }

        return false;
    };

    // Public
    return {
        init,
        getLng,
        setRegulationTermsParams,
        getCurrency,
        getThemeUri,
        getFrameworkUri,
        showRegistrationOrLogin,
        showLogin,
        showRegistration,
        showDeposit,
        onSessionStatusUpdate,
        changeLanguage,
        navigateTo,
        openInfoPopup,
        openPaymentMethodsPopup,
        showContactUs,
        showMyAccount,
        showChangePassword,
        showGamesHistory,
        showTransactionsHistory,
        showDepositLimit,
        showSelfExclusion,
        getBrandDomain,
        getCurrentGameId,
        getCurrentGame,
        loadGame,
        switchToMoneyMode,
        iSoftBetDataLoad,
        isGameNeedISoftBetPopUp,
        closeGame,
        logout,
        showWithdraw,
        showMyRewards,
        getDisplayBalance,
        getLoyaltyPoints,
        getBannerData,
        getBannersWeb,
        getBannersMobile,
        getBannersSpecial,
        getBannersPopups,
        getbannerLinkType,
        showGameSearch,
        setActionEvents,
        unsetActionEvents,
        showChat,
        showRealityCheck,
        getUniversalImagesUri,
        getGeneralImagesUri,
        getCrmImagesUri,
        getGameThumbImagesUri,
        setRegulationTerms,
        playNow,
        execBtnAction,
        execPromotionCTA,
        playNowWithOrientationCheck,
        GAeventTracking,
        eventTrack,
        isSportActive,
        isSportVertical,
        isDoubleGameSize,
        isAustria,
        checkUserStatusCookie,
        gestatesExistingUser,
        getCountry,
        setIntervalForRefreshBalance,
        refreshBalance,
        stopBalanceInterval,
        isSportPage,
        ng_openPage,
        getUserStatusText,
        getCurrencySign,
        getDomainSuffixes,
        isUkCountry,
        isDEcountry,
        isNoDemoGamesCountry,
        isSessionClockBarCountry,
        hasAustriaFlag,
        showChatAfterLogin,
        initFlyingNotification,
        terminateFlyingNotification,
        getExternalLoyaltyApiData,
        isHOmePage,
        balanceUpdateUkMode,
        isPhoneGap,
        isBrandDK,
        showDocumentUpload,
        redirectPageGamesBasedList,
        redirectPageGameIfGameNotExist,
        getLoginTimeDuration,
        dictionaryReady,
        partialsReady,
        getPreloadData,
        openSwishApp,
        onLoginCallback,
        stripHtml,
        getFullRegulationText,
        isVirtualSportsActive,
        getForbiddenSportCountries,
        getBonusMessageTimeout,
        getPayNPlayData,
        getAllPromotionsNumber,
        isPayNPlayEnabled,
        getCountOfEvolutionGamesItem,
        isCuracaoRegulation,
        loadExtraScripts,
        loadAdScore,
        loadChatProvider,
        goInFullscreenById,
        goOutFullscreen,
        showVerificationStrip,
        destroyVerificationStrip,
        isGermanyBuyWinActive,
        getGermanyBuyWinExcludedSubProviders,
        closeWalkThroughIfOpen,
        isShowWalkThrough,
        openWalkThroughSkip,
        renderPlayerVerificationStripComponent,
        getExponeaToken,
        getSportSlug,
        getSportWidgetSlug,
        getStatusBarPage,
        redirectToLobby,
        cookieNames,
        getSlugFromString,
        isFullScreenCurrently,
        isGamePageTemplate,
        isGamesListPageTemplate,
        isSportPageTemplate,
        isCasinoPageTemplate,
        setCookieWalkThroughStatus,
        getMobileOsType,
        getPlatformName,
        getVerticals,
        setCurrentVerticalId,
        setCurrentVerticalIdCookie,
        getCurrentVertical,
        setCurrentCategorySet,
        getCurrentCategorySet,
        openFirstVertical,
        getLeftMenuData,
        exitGameMessageCheck,
        getIsOneOfNativeApps,
        getIsNativeApp,
        getIsNativeSsoApp,
        getIsNativeFooterMenuVisible,
        getIsNativeSocialMediaVisible,
        getIsNativeCopyRightVisible,
        getBalanceFoldData,
        isSingleVerticalTypeBrand,
        getDefaultLocationForVerticalType,
        verticalTypesEnum,
        verticalActionTypesEnum,
        callVerticalsMenuApi,
        setAppStateToStore,
        isLoyaltyAvailable,
        mapUnsegmentedBanners,
        setGameVerticalIdCookie,
        getPlaceholderBannerData,
        getSegmentedBanners,
        getUnsegmentedBanners,
        isLtPromotionsEnabled,
        isPromotionsPage,
        isPromotionPage,
        isVerticalPage,
        getIsSearchEnabled,
        applyPlatformDeepLinks,
        isEmbeddedGamePageEnabled,
        isNeoCmsIntegrationEnabled,
    };
})();

/**
 * Player
 * */
const Player = (function () {
    const onLogin = function () {
        updateUserStatusCookie(1);
        document.dispatchEvent(new Event('LoggedIn'));
        AsgApp.setIntervalForRefreshBalance();
        addRestrictionsByCountry();
        if (AsgApp.showChatAfterLogin()) {
            AsgFW.showChat();
        }
        AsgApp.onLoginCallback();
        AsgFW.startMeasureSessionTime();
        checkLoggedInRefreshNeeded();
        setPlayerSessionToStore();
        setPlayerBalanceToStore();
    };

    /**
     * Reload the page in case post-login player by country is needed
     * for any reason (languages dropdown update etc..)
     */
    const checkLoggedInRefreshNeeded = function () {
        const refreshNeededCountries = ['nl'];
        const playerCountryCode = convertCountryCode(AsgFW.getPlayerCountryCode())
            .toLowerCase();
        const lastCookieCountryCode = Cookie.read('lastUserCountryCode');
        if (refreshNeededCountries.includes(playerCountryCode)
            && playerCountryCode !== AsgApp.getCountry()
            && playerCountryCode !== lastCookieCountryCode) {
            setLastUserCountryCodeCookie(playerCountryCode);
            location.reload();
        }
    };

    const addRestrictionsByCountry = function () {
        const data = Player.getSessionDetails();
        const forbiddenSportCountriesArr = AsgApp.getForbiddenSportCountries();
        if (forbiddenSportCountriesArr.indexOf(data.CountryCode.toLowerCase()) > -1 && Cookie.read('closeSport') !== '1') {
            Cookie.create('closeSport', '1', '180');
            if (data.CountryCode.toLowerCase() !== AsgApp.getCountry().toLowerCase()) {
                location.reload(true);
            }
        }
    };

    const convertCountryCode = function (code) {
        let result = code;
        if (code === 'GB') {
            result = 'uk';
        }
        return result;
    };

    const updateUserStatusCookie = function (status) {
        Cookie.create('lastTimeStatus', status, '180', '/');
    };

    const setLastUserCountryCodeCookie = function (data) {
        Cookie.create('lastUserCountryCode', data, '180', '/');
    };

    const isLoggedIn = function () {
        return AsgFW.isLoggedIn();
    };

    const getPlayerName = function () {
        return AsgFW.getPlayerName();
    };

    const getPlayerID = function () {
        return AsgFW.getPlayerID();
    };

    const getLoginTimeStamp = function () {
        return AsgFW.getLoginTimeStamp();
    };

    const getLastLoginTimeStamp = function () {
        return AsgFW.getLastLoginTimeStamp();
    };

    const getServerTimeStamp = function () {
        return AsgFW.getServerTimeStamp();
    };

    const isRegistered = function () {
        return AsgFW.isRegistered();
    };

    const getSessionDetails = function () {
        return AsgFW.getSessionDetails();
    };

    const isPlayedGame = function (mode) {
        const localMode = mode || 'D';
        return !!Cookie.read(`isGamePlayed${localMode}`);
    };

    const onLogout = function () {
        updateUserStatusCookie(0);
        document.dispatchEvent(new Event('LoggedOut'));
        AsgApp.stopBalanceInterval();

        // close embedded game
        if (window.AsgSharedComponents) {
            const { closeEmbeddedGame } = AsgSharedComponents.getActionCreators();

            AsgSharedComponents.dispatch(closeEmbeddedGame());
        }
    };

    const logout = function () {
        AsgFW.logout();
    };

    const setPlayerSessionToStore = () => {
        if (window.AsgSharedComponents) {
            const {
                regulation,
                brand,
                country,
            } = AsgFW.getRBC();

            const {
                setPlayerSession,
                setRbc,
                setLoyalty,
            } = AsgSharedComponents.getActionCreators();

            if (!AsgFW.isLoggedIn()) {
                AsgSharedComponents.dispatch(setPlayerSession(null));
                AsgSharedComponents.dispatch(setLoyalty(null));
            }

            const session = AsgFW.getSessionDetails();
            session.PlayerRegulationType = AsgFW.ngRegulationToAsg(session.PlayerRegulationType);

            AsgSharedComponents.dispatch(setPlayerSession(session));
            AsgSharedComponents.dispatch(setLoyalty(AsgFW.getLoyaltyPoints()));
            AsgSharedComponents.dispatch(setRbc({
                regulation,
                casinoId: brand,
                countryCode: country,
            }));
        }
    };

    const setPlayerBalanceToStore = () => {
        if (window.AsgSharedComponents) {
            const { setBalance } = AsgSharedComponents.getActionCreators();
            AsgSharedComponents.dispatch(setBalance(AsgFW.getDisplayBalance()));
        }
    };

    return {
        isLoggedIn,
        getPlayerName,
        getPlayerID,
        getLoginTimeStamp,
        getLastLoginTimeStamp,
        getServerTimeStamp,
        onLogin,
        onLogout,
        logout,
        isRegistered,
        isPlayedGame,
        updateUserStatusCookie,
        checkLoggedInRefreshNeeded,
        getSessionDetails,
        setPlayerSessionToStore,
        setPlayerBalanceToStore,
    };
})();

/**
 * Games
 *
 * */
const Games = (function () {
    let allGames;
    let allGamesByName = {};
    let allGamesById = {};
    let bingoRoomIds = [];
    let bingoLobbyId = null;
    let categories;
    let gameItemPartial;
    let gameCategoryPartial;
    let gameSubCategoryPartial;
    let gameSearchPartial;
    let gameSearchSpecialPartial;
    let recentGames = [];
    let freeGamesList = [];
    const isGamesUpdated = $.Deferred();
    let preloadGames = [];
    let sortGameStatus = false;
    let filterGamesWorker;
    let prepareGamesWorker;
    let prepareBuyWinCategoryWorker;
    let updateVerticalsObjectWorker;

    const isGglBrandActive = function () {
        return true;
    };

    const init = function () {
        filterGamesWorker = new Worker(`${AsgApp.getThemeUri()}workers/filter-duplicate-games.worker.js`);
        prepareGamesWorker = new Worker(`${AsgApp.getThemeUri()}workers/prepare-games-data.worker.js`);
        prepareBuyWinCategoryWorker = new Worker(`${AsgApp.getThemeUri()}workers/prepare-buy-win-category.worker.js`);
        updateVerticalsObjectWorker = new Worker(`${AsgApp.getThemeUri()}workers/update-verticals.worker.js`);
    };

    const updateAllGames = function (data) {
        allGames = data.games.instant;
        categories = data.categories;

        prepareGamesData()
            .then(filterDuplicateGames)
            .then(prepareBuyWinCategory)
            .then(setBingoGamesToStore)
            .then(setGamesReadyToStore)
            .then(() => {
                isGamesUpdated.resolve();
                AsgApp.applyPlatformDeepLinks();
                document.dispatchEvent(new Event('gameUpdateFinished'));
            });
    };

    const processCmsGames = function (data) {
        allGames = Object.values(data);
        categories = {
            mainCategories: [],
        };

        prepareGamesData()
            .then(setBingoGamesToStore)
            .then(() => {
                AsgFW.setCmsGamesList(allGames, allGamesById, allGamesByName);
                return Promise.resolve();
            })
            .then(setGamesReadyToStore)
            .then(() => {
                isGamesUpdated.resolve();
                document.dispatchEvent(new Event('gameUpdateFinished'));
            });
    };

    // Force games update from NG after 'justLoggedIn' and 'justLoggedOut' events.
    // TODO: TOREMOVE when NG will trigger update games on login themselves again.
    $(document).on('justLoggedIn justLoggedOut', function () {
        ng_fw.updateGamesList();
    });

    const isExclusiveGame = function (gameId) {
        return AsgFW.isExclusiveGame(gameId);
    };

    const getGameFlagStatus = function (game) {
        freeGamesList = ng_fw.getDisplayBalance().FreeGames;
        let FlagStatus = game.gameConfig[0];
        $.each(freeGamesList, function (key, value) {
            if (value.GameID === game.id) {
                FlagStatus = 'free';
            }
        });
        return FlagStatus;
    };

    const loadPartials = function () {
        const partialsRequest = $.Deferred();
        const categoryItemRequest = $.get(`${AsgApp.getThemeUri()}partials/category_item.php`, function (data) {
            gameCategoryPartial = data;
        });

        const subCategoryItemRequest = $.get(`${AsgApp.getThemeUri()}partials/sub_category_item.php`, function (data) {
            gameSubCategoryPartial = data;
        });

        const gameItemRequest = $.get(`${AsgApp.getThemeUri()}partials/game_item.php`, function (data) {
            gameItemPartial = data;
        });

        $.when(categoryItemRequest, gameItemRequest, subCategoryItemRequest).done(function () {
            $(document).trigger('partialsReady');
            AsgApp.partialsReady();
            partialsRequest.resolve();
        });

        $.when(partialsRequest, isGamesUpdated).done(function () {
            Tools.track('gamesReadyEvent');
            $(document).trigger('gamesReady');
        });
    };

    /**
     * Retrieve recently played games for logged in user.
     */
    const fetchRecentGames = function () {
        if (Player.isLoggedIn()) {
            AsgFW.getRecentGames(function (rGames) {
                recentGames = rGames.map(function (rGame) {
                    return rGame.gameId;
                });
                // Add recent games to the other categories.
                addRecentGames();
                // Trigger event for templates actions.
                $(document).trigger('recentGamesUpdated');
                if (recentGames.length > 0) {
                    $('.recent-games-count').html(recentGames.length);
                    $('.hide-category').removeClass('hide-category');
                }

                setRecentGamesToStore();
            }).catch(function () {
                console.error('Fetching of the recent games failured.');
            });
        } else {
            // Not logged in user doesn't have recently played games.
            recentGames = [];
            $('.recent-games-count').parent().addClass('hide-category');
            setRecentGamesToStore();
        }
    };

    /**
     * Update categories and subcategories with Recent games.
     */
    const addRecentGames = function () {
        if (AsgApp.isNeoCmsIntegrationEnabled()) {
            return;
        }

        const gamesCategories = categories.mainCategories;
        if (AsgFW.isMobilePamPlatform()) {
            Games.addRecentGamesCategories(gamesCategories, Games.getDefaultCategory() + 1);
        } else {
            gamesCategories.forEach(function (cat) {
                Games.addRecentGamesSubCategories(cat.subCategories, -1);
            });
        }
    };

    // Some event handlers to manipulate with Recent games behaviour
    $(document).on('LoggedIn LoggedOut endInGame', function () {
        fetchRecentGames(); // Fetch recently played games from NG.
    });

    /**
     * Hide Recent games category / subcategory
     * curSubCatName - put a name of category to comapare Recent games name with.
     * @param curSubCat
     */
    const hideSortForRecents = function (curSubCatName) {
        if (curSubCatName === Games.recentGamesName()) {
            $('.games-sort').hide();
        } else {
            $('.games-sort').show();
        }
    };

    $('.games-sort').on('click', function () {
        sortGameStatus = !sortGameStatus;
        const GAcategory = 'Main Screen';
        const GAaction = (sortGameStatus) ? 'Sort A/Z' : 'Sort Z/A';
        const GAlabel = (Player.isLoggedIn()) ? 'Click sort post login' : 'Click sort pre login';
        AsgApp.GAeventTracking(GAcategory, GAaction, GAlabel);
    });

    const recentGamesName = function () {
        if (AsgFW.isMobilePamPlatform()) {
            return Dictionary.translate('recent');
        }
        return Dictionary.translate('recentGames');
    };

    /**
     * @param Cat
     * @param location is never used
     * @param isLocationOn if for turning on location parameter
     * it is added in order to avoid changes across all templates
     * @returns {*}
     */
    const addRecentGamesCategories = function (Cat, location, isLocationOn) {
        const localIsLocationOn = isLocationOn || false;
        const recentGamesForMobile = recentGames.length > 8 ? recentGames.slice(0, 8) : recentGames;
        const recentGamesObjects = {
            name: recentGamesName(),
            defaultSubCategoryIndex: 0,
            extraElement: `<span class="recent-games-count">${recentGamesForMobile.length}</span>`,
            subCategories: [{ name: recentGamesName(), instantGamesOrder: recentGamesForMobile }],
        };
        if (localIsLocationOn) {
            // eslint-disable-next-line no-param-reassign, no-multi-assign
            categories.mainCategories = Cat = addRecentGamesByLocation(Cat,
                location, recentGamesObjects);
        } else {
            // Avoid recent category duplicating - replace recent games item,
            // if it was already created.
            // eslint-disable-next-line no-lonely-if
            if (
                categories.mainCategories[categories.mainCategories.length - 1].name
                === recentGamesObjects.name
            ) {
                categories.mainCategories.splice(-1, 1, recentGamesObjects);
            } else {
                // eslint-disable-next-line no-param-reassign, no-multi-assign
                categories.mainCategories = Cat = addRecentGamesByLocation(
                    Cat,
                    -1,
                    recentGamesObjects,
                );
            }
        }
        return Cat;
    };

    const addRecentGamesSubCategories = function (subC, location) {
        const recentCount = recentGames.length > 0 ? recentGames.length.toString() : '';
        const extraElement = `<span class="recent-games-count">${recentCount}</span>`;
        const recentGamesObjects = {
            name: recentGamesName(),
            instantGamesOrder: recentGames,
            extraElement,
        };
        const result = $.grep(subC, function (e) {
            return e.name === recentGamesName();
        });
        if (result.length === 0) {
            // eslint-disable-next-line no-param-reassign
            subC = addRecentGamesByLocation(subC, location, recentGamesObjects);
        } else {
            subC.forEach(cat => {
                if (cat.name === recentGamesName()) {
                    // eslint-disable-next-line no-param-reassign
                    cat.extraElement = extraElement;
                    // eslint-disable-next-line no-param-reassign
                    cat.instantGamesOrder = recentGames;
                }
            });
        }

        return subC;
    };

    const addRecentGamesByLocation = function (theElement, whereToAdd, whatToAdd) {
        if (whereToAdd === -1) {
            theElement.push(whatToAdd);
        } else {
            const part1 = theElement.slice(0, whereToAdd);
            const part2 = theElement.slice(whereToAdd);
            part1.push(whatToAdd);
            // eslint-disable-next-line no-param-reassign
            theElement = $.merge(part1, part2);
        }
        return theElement;
    };

    const getCategoryGames = function (category) {
        return categories.mainCategories[category].subCategories[0].instantGamesOrder;
    };

    const getCategoryName = function (category) {
        return categories.mainCategories[category].name;
    };

    const getCategoryGamesWeb = function (category, subcategory) {
        return categories.mainCategories[category].subCategories[subcategory].instantGamesOrder;
    };

    const getDefaultCategory = function () {
        return categories.defaultMainCategoryIndex;
    };

    const getDefaultSubCategory = function (category) {
        const localCategory = (category === undefined) ? 0 : category;
        const hasCategory = Object.prototype.hasOwnProperty.call(
            categories.mainCategories,
            localCategory,
        );

        if (hasCategory) {
            return categories.mainCategories[localCategory].defaultSubCategoryIndex;
        }

        return 0;
    };

    const getGameDetails = function (gid) {
        return allGamesById[gid];
    };

    /**
     * Get game images from game object
     * If keys images, images.default or images.webp not exist there,
     * preloader-gif from UniversalImagesUri will set by default
     */
    const getGameImageFromGameObject = function (game) {
        const preloaderImg = `${AsgApp.getUniversalImagesUri()}web-elements/preloader-gif.gif`;
        const hasImages = Object.prototype.hasOwnProperty.call(game, 'images');
        const hasDefault = hasImages && Object.prototype.hasOwnProperty.call(game.images, 'default');
        const hasWebp = hasImages && Object.prototype.hasOwnProperty.call(game.images, 'webp');

        return {
            placeHolderImage: preloaderImg,
            gameImg: hasDefault ? game.images.default : preloaderImg,
            gameImgWebp: hasWebp ? game.images.webp : preloaderImg,
        };
    };

    const getCategories = function () {
        return categories.mainCategories;
    };

    const isPresentPageGames = function (gid) {
        return AsgFW.isPresentPageGames(gid);
    };

    const prepareGamesData = function () {
        return new Promise((resolve, reject) => {
            prepareGamesWorker.postMessage({
                allGames,
                gameVerticalCodeToIdEnum: AsgFW.GameVerticalCodeToIdEnum,
            });

            prepareGamesWorker.onmessage = (e) => {
                allGames = e.data.allGames;
                allGamesByName = e.data.allGamesByName;
                allGamesById = e.data.allGamesById;
                bingoRoomIds = e.data.bingoRoomIds;
                bingoLobbyId = e.data.bingoLobbyId;
                resolve();
            };

            prepareGamesWorker.onerror = () => {
                reject(new Error('prepareGamesWorker failed'));
            };
        });
    };

    const setBingoGamesToStore = function () {
        return new Promise((resolve) => {
            try {
                if (window.AsgSharedComponents && bingoRoomIds.length > 0) {
                    const {
                        fillBingoRoomIds,
                        fillBingoLobbyId,
                    } = AsgSharedComponents.getActionCreators();
                    AsgSharedComponents.dispatch(fillBingoRoomIds(bingoRoomIds));

                    if (bingoLobbyId !== null) {
                        AsgSharedComponents.dispatch(fillBingoLobbyId(bingoLobbyId));
                    }
                }
            } catch (e) {
                Tools.error('setBingoGamesToStore failed', e.message);
            }

            resolve();
        });
    };

    const filterDuplicateGames = function () {
        return new Promise((resolve, reject) => {
            filterGamesWorker.postMessage({
                preloadGames,
                categories,
            });

            filterGamesWorker.onmessage = (e) => {
                categories = e.data.categoriesUpdated;
                resolve();
            };

            filterGamesWorker.onerror = () => {
                reject(new Error('filterGamesWorker failed'));
            };
        });
    };

    const fetchBuyWinOrderedGames = function () {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve) => {
            if (AsgApp.isGermanyBuyWinActive()) {
                fetch(`${AsgApp.getFrameworkUri()}data/general-data/GermanyBuyWinOrderedGames.json`)
                    .then(response => response.json())
                    .then(list => {
                        resolve(JSON.parse(list));
                    }).catch(e => {
                        console.error('Error in fetching BuyWin ordered games list', e);
                        resolve([]);
                    });
            }
        });
    };

    const prepareBuyWinCategory = function () {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            if (!AsgApp.isGermanyBuyWinActive()) {
                resolve();
                return;
            }

            const GermanyBuyWinOrderedGames = await fetchBuyWinOrderedGames();
            const excludedSubProviders = AsgApp.getGermanyBuyWinExcludedSubProviders();
            const isMobile = AsgFW.isMobilePamPlatform();
            const catName = Dictionary.translate('BuyWin');
            const subCatName = Dictionary.translate('BuyWin');

            prepareBuyWinCategoryWorker.postMessage({
                allGames,
                categories,
                catName,
                subCatName,
                isMobile,
                excludedSubProviders,
                GermanyBuyWinOrderedGames,
            });

            prepareBuyWinCategoryWorker.onmessage = (e) => {
                // update categories with new buywin entry
                categories = e.data.categoriesUpdated;

                // update buywin data in redux
                setBuyWinDataToStore({
                    allBuyWinGamesIds: e.data.allBuyWinGameIds,
                    excludedSubProviders,
                });

                resolve();
            };

            prepareBuyWinCategoryWorker.onerror = () => {
                reject(new Error('prepareBuyWinCategoryWorker failed'));
            };

            // hide buywin icons for excluded providers
            const style = document.createElement('style');
            excludedSubProviders.forEach((excludedSubProvider) => {
                const subProviderNamePrepared = excludedSubProvider.replace(/[ ]/g, '-');
                style.innerHTML += `.sub-provider-${subProviderNamePrepared} .buywin-icon { display: none!important; }`;
            });
            document.getElementsByTagName('head')[0].appendChild(style);
        });
    };

    const getSubCategories = function (category) {
        addRecentGames();
        return categories.mainCategories[category].subCategories;
    };

    const generateCategoryItem = function (name, order, pageTemplate, extraElement) {
        const localExtraElement = extraElement || '';
        const ssostatus = Player.isLoggedIn() ? 'Post' : 'Pre';
        let txt = Tools.replaceAll(gameCategoryPartial, '[category]', name);
        txt = txt.replace('[class]', `game-category-${order}`);
        txt = Tools.replaceAll(txt, '[extraElement]', localExtraElement);
        txt = Tools.replaceAll(txt, '[ssostatus]', ssostatus);
        txt = Tools.replaceAll(txt, '[codeName]', categories.mainCategories[order].codeName || '');

        const gamesArr = Games.getCategoryGamesWeb(order, 0);
        if (gamesArr.length === 0) {
            txt = hideStringElement(txt);
        }

        if (pageTemplate === 'page.php') {
            return txt.replace('[hash]', '');
        }
        return txt.replace('[hash]', `/?game-category=${order}`);
    };

    const generateSubCategoryItem = function (name, order, category, extraElement) {
        const localExtraElement = extraElement || '';
        let txt = Tools.replaceAll(gameSubCategoryPartial, '[subcategory]', name);
        const ssostatus = Player.isLoggedIn() ? 'Post' : 'Pre';

        txt = Tools.replaceAll(txt, '[id]', `id=sub-${order}`);
        txt = Tools.replaceAll(txt, '[id-mob]', `id=mob-sub-${order}`);
        txt = Tools.replaceAll(txt, '[index]', order);
        txt = Tools.replaceAll(txt, '[theme_uri]', AsgApp.getThemeUri());
        txt = Tools.replaceAll(txt, '[image]', name.replace(/\s+/g, '-').toLowerCase());
        txt = Tools.replaceAll(txt, '[extraElement]', localExtraElement);
        txt = Tools.replaceAll(txt, '[ssostatus]', ssostatus);
        txt = Tools.replaceAll(txt, '[codeName]', categories.mainCategories[category].subCategories[order].codeName || '');

        let gamesArr;
        if (AsgFW.isMobilePamPlatform()) {
            gamesArr = Games.getCategoryGamesWeb(category, 0);
        } else {
            gamesArr = Games.getCategoryGamesWeb(category, order);
        }
        if (gamesArr.length === 0) {
            txt = hideStringElement(txt);
        }
        return txt;
    };

    function hideStringElement(element) {
        // eslint-disable-next-line no-param-reassign
        element = $(element);
        // eslint-disable-next-line no-param-reassign
        element = $(element).addClass('hide-category');

        return $(element)[0].outerHTML;
    }

    const generateSubCategoryItemByCategory = function (name,
        order, imageName, category, extraElement) {
        // eslint-disable-next-line no-param-reassign
        extraElement = extraElement || '';
        let txt = gameSubCategoryPartial.replace('[subcategory]', name);
        txt = txt.replace('[universalImagesUri]', AsgApp.getUniversalImagesUri());
        txt = txt.replace('[id]', order);
        txt = txt.replace('[imageName]', imageName);
        txt = txt.replace('[theme_dir]', AsgApp.getThemeUri());
        txt = txt.replace('[subcategoryImageName]', name);
        txt = Tools.replaceAll(txt, '[extraElement]', extraElement);
        txt = Tools.replaceAll(txt, '[codeName]', categories.mainCategories[category].subCategories[order].codeName || '');

        const gamesArr = Games.getCategoryGamesWeb(category, order);
        if (gamesArr.length === 0) {
            txt = hideStringElement(txt);
        }
        return txt;
    };

    /**
     *
     * @param gid
     * @param name
     * @param img
     * @param imgWebp
     * @param size
     * @param noDemoFlag
     * @param customTemplateFlag
     * @param specialPartition
     * @param searchTerm
     * @param provider
     * @param subProvider
     * @returns {*}
     */
    const generateGameItem = function (
        gid,
        name,
        img,
        imgWebp,
        size,
        noDemoFlag,
        customTemplateFlag,
        specialPartition,
        searchTerm,
        provider,
        subProvider,
    ) {
        const localSpecialPartition = specialPartition || 'games_search_item';
        let generatedItem;
        if (customTemplateFlag === true) {
            if (localSpecialPartition === 'games_search_item') {
                if (gameSearchPartial == null) {
                    $.ajaxSetup({ async: false });
                    $.get(`${AsgApp.getThemeUri()}partials/${localSpecialPartition}.php`, function (data) {
                        gameSearchPartial = data;
                    });
                    $.ajaxSetup({ async: true });
                }
                generatedItem = gameSearchPartial;
            } else {
                if (gameSearchSpecialPartial == null) {
                    $.ajaxSetup({ async: false });
                    $.get(`${AsgApp.getThemeUri()}partials/${localSpecialPartition}.php`, function (data) {
                        gameSearchSpecialPartial = data;
                    });
                    $.ajaxSetup({ async: true });
                }
                generatedItem = gameSearchSpecialPartial;
            }
        } else {
            generatedItem = gameItemPartial;
        }

        // eslint-disable-next-line max-len
        generatedItem = replaceGameItemDynamicParameters(generatedItem, gid, name, img, imgWebp, size, noDemoFlag, searchTerm, provider, subProvider);
        return Dictionary.translateString(generatedItem);
    };

    /**
     *
     * @param generatedItem
     * @param gid
     * @param name
     * @param img
     * @param imgWebp
     * @param size
     * @param noDemoFlag
     * @param searchTerm
     * @param provider
     * @param subProvider
     * @returns {*}
     */
    const replaceGameItemDynamicParameters = function (
        generatedItem,
        gid,
        name,
        img,
        imgWebp,
        size,
        noDemoFlag,
        searchTerm,
        provider,
        subProvider,
    ) {
        const localProvider = provider || '';
        const localSubProvider = subProvider || provider;
        const colSize = size || '2';
        const localName = name || '';
        const localGid = gid || '';
        let localImg = img || '';
        let localImgWebp = imgWebp || '';
        let localNoDemoFlag;
        let localGeneratedItem = generatedItem;

        localNoDemoFlag = noDemoFlag || 0;

        if (AsgApp.isNoDemoGamesCountry()) {
            localNoDemoFlag = 1;
        }

        if (size === 1) {
            localImg = localImg.replace('_1x_', '_1x1_');
            localImgWebp = localImgWebp.replace('_1x_', '_1x1_');
            localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[default_image]', `${AsgApp.getUniversalImagesUri()}web-elements/spinner_square.gif`);
        } else if (size === 4) {
            localImg = localImg.replace('290x', '594x');
            localImg = localImg.replace('_1x_', '_2x_');
            localImgWebp = localImgWebp.replace('290x', '594x');
            localImgWebp = localImgWebp.replace('_1x_', '_2x_');
            localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[default_image]', `${AsgApp.getUniversalImagesUri()}web-elements/spinner_big.gif`);
        } else {
            localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[default_image]', `${AsgApp.getUniversalImagesUri()}web-elements/spinner_small.gif`);
        }
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[gid]', localGid);
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[name]', localName);
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[name-slug]', AsgApp.getSlugFromString(localName));
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[theme_dir]', AsgApp.getThemeUri());
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[img]', localImg);
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[imgWebp]', localImgWebp);
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[search_term]', searchTerm);
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[provider]', localProvider.replace(/[ ]/g, '-'));
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[sub_provider]', localSubProvider.replace(/[ ]/g, '-'));
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[play_to_win]', Dictionary.translate('playToWin'));
        localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[play_to_fun]', Dictionary.translate('playForFun'));

        if (size >= 0 && size < 4) {
            localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[size]', colSize);
        } else {
            localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[demopage]', 'no-demo');
        }
        if (isNoDemoGame(gid) || localNoDemoFlag === 1) {
            localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[extraclass]', ' no-demo');
        } else {
            localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[extraclass]', '');
        }
        if (isNoDemoGame(gid)) {
            localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[extraclass-2]', ' no-demo');
            localGeneratedItem = Tools.replaceAll(localGeneratedItem, '[demopage]', 'no-demo');
        }
        return localGeneratedItem;
    };

    const searchGameByName = function (
        searchVal,
        noDemoFlag,
        customTemplateFlag,
        specialPartition,
        getObj,
    ) {
        // eslint-disable-next-line no-param-reassign
        specialPartition = specialPartition || false;
        // eslint-disable-next-line no-param-reassign
        getObj = getObj || false;
        // eslint-disable-next-line no-param-reassign
        customTemplateFlag = customTemplateFlag || false;
        // eslint-disable-next-line no-param-reassign
        noDemoFlag = noDemoFlag || false;

        let colmd = 2;
        if (customTemplateFlag) {
            colmd = 0;
        }

        // eslint-disable-next-line no-param-reassign
        searchVal = AsgApp.stripHtml(searchVal.toLowerCase());
        const len = searchVal.length;
        // extracted HTML games after search terms
        let html = '';
        const searchResults = [];
        let searchResultsByName = [];
        let searchResultsByProvider = [];
        let searchResultsBySubProvider = [];
        // final games object
        const objects = [];

        if (len >= 1) {
            searchResultsByName = filterGamesByName(searchVal, allGames);
            searchResultsByProvider = filterGamesByProvider(searchVal, allGames);
            searchResultsBySubProvider = filterGamesBySubProvider(searchVal, allGames);
            searchResults.push(
                ...searchResultsByName,
                ...searchResultsBySubProvider,
                ...searchResultsByProvider,
            );

            // eslint-disable-next-line guard-for-in
            for (const i in searchResults) {
                const val = searchResults[i];

                if (val.externalGameProvider === 'NetEnt' && AsgFW.isHideNetentGames()) {
                    continue;
                }

                const gameSubProvider = val.externalGameSubProvider;
                const gameProvider = gameSubProvider || val.externalGameProvider;

                if (AsgFW.isActiveAppealingToChildrenFilter()
                    || (AsgApp.isNoDemoGamesCountry() && !Player.isLoggedIn())
                ) {
                    if (!Tools.ifKeyExists(searchResults[i].id.toString(),
                        AsgFW.getNotPresentGamesList().GameListId)) {
                        objects.push(val);
                        const item = $(generateGameItem(val.id, val.name, val.images.default,
                            val.images.webp, colmd, 1, customTemplateFlag,
                            specialPartition, searchVal, gameProvider, gameSubProvider));
                        // remove demo link from game html
                        $(item).find('.demo-game-link-btn, .no-demo').removeAttr('href').attr({
                            'data-action': 'loadGame',
                            'data-action-info': `${val.id}|Z`,
                        });
                        html += item[0].outerHTML;
                    }
                } else {
                    objects.push(val);
                    html += generateGameItem(val.id, val.name,
                        val.images.default, val.images.webp, colmd,
                        noDemoFlag, customTemplateFlag, specialPartition,
                        searchVal, gameProvider, gameSubProvider);
                }
            }

            if (!searchResults.length) {
                html = `<li class="no-results"><p>${(Dictionary.translate('noResults'))}</p></li>`;
            } else {
                html = `<li class="results-count">${objects.length} ${Dictionary.translate('resultsFor')} <span class="result-term">${searchVal}</span></li>${html}`;
            }
        }
        return getObj ? objects : html;
    };

    /**
     * Search games by game name
     */
    const filterGamesByName = function (searchVal, games) {
        const searchRegExp = new RegExp(searchVal, 'i');
        return games.filter(function (g) {
            return searchRegExp.test(g.name);
        });
    };

    /**
     * Search games by provider name
     */
    const filterGamesByProvider = function (searchVal, games) {
        const searchRegExp = new RegExp(searchVal, 'i');
        return games.filter(function (g) {
            return !searchRegExp.test(g.name) && searchRegExp.test(g.externalGameProvider) && (g.externalGameSubProvider === '' || g.externalGameSubProvider === g.externalGameProvider);
        });
    };

    /**
     * Search games by sub provider name
     */
    const filterGamesBySubProvider = function (searchVal, games) {
        const searchRegExp = new RegExp(searchVal, 'i');
        return games.filter(function (g) {
            return searchRegExp.test(g.externalGameSubProvider);
        });
    };

    /**
     * return games list after filtering duplicates & replaced provider names
     */
    const getFixedGamesList = function () {
        return allGames;
    };

    const getGameById = function (gid) {
        return allGamesById[gid];
    };

    const getGameNameById = function (gid) {
        const localGame = getGameById(gid);
        const hasName = Boolean(localGame) && Object.prototype.hasOwnProperty.call(localGame, 'name');
        return hasName ? localGame.name : null;
    };

    const getGameByName = function (name) {
        return allGamesByName[name.toLowerCase().trim()];
    };

    /**
     *
     * @param gid
     * @returns {boolean}
     */
    const isNoDemoGame = function (gid) {
        const hasPlayModes = Object.prototype.hasOwnProperty.call(Games.getGameById(gid), 'playModes');
        if (Games.getGameById(gid) && hasPlayModes) {
            if (Games.getGameById(gid).playModes.indexOf('Demo') > -1) {
                return false;
            }
        }
        return true;
    };

    const setPreloadGames = function (gamesArr) {
        preloadGames = gamesArr;
    };
    /**
     * Sort the games order alphabetically, for a specific subcategory.
     * @param {boolean} isReverse. true - from a to z, false - from z to a.
     * @param {integer} category.
     * @param {integer} subCategory.
     */
    const sortGames = function (isReverse, category, subCategory) {
        const subCategoryNewOrder = [];
        categories.mainCategories[category]
            .subCategories[subCategory].instantGamesOrder.forEach(function (gid) {
                subCategoryNewOrder.push(Games.getGameById(gid));
            });
        if (isReverse) {
            subCategoryNewOrder.sort((a, b) => {
                const firstCategoryName = a.name.trim().toLowerCase();
                const secondCategoryName = b.name.trim().toLowerCase();

                return firstCategoryName > secondCategoryName ? -1 : 1;
            });
        } else {
            subCategoryNewOrder.sort((a, b) => {
                const firstCategoryName = a.name.trim().toLowerCase();
                const secondCategoryName = b.name.trim().toLowerCase();

                return firstCategoryName > secondCategoryName ? 1 : -1;
            });
        }
        categories.mainCategories[category].subCategories[subCategory]
            // eslint-disable-next-line array-callback-return
            .instantGamesOrder = subCategoryNewOrder.map(game => {
                if (game) return game.id;
            });
    };

    const liveCasinoStart = function () {
        if (window.AsgLiveCasino) {
            window.AsgLiveCasino.subscribe();
            Tools.log('Subscribed to Live Casino feed');
        }
    };

    const liveCasinoStop = function () {
        if (window.AsgLiveCasino) {
            window.AsgLiveCasino.stop();
            Tools.log('Unsubscribed from Live Casino feed');
        }
    };

    const liveCasinoRefresh = function () {
        if (window.AsgLiveCasino) {
            window.AsgLiveCasino.refresh();
            Tools.log('Live Casino feed re-rendered');
        }
    };

    const gameImprovementsRender = function () {
        if (window.AsgGameImprovements) {
            window.AsgGameImprovements.render();
        }
    };

    /**
     * get provider name by game id
     */
    const getProviderByGameId = (gameId) => {
        const game = getGameById(gameId);
        return game && game.externalGameProvider ? game.externalGameProvider : null;
    };

    /**
     * return true if provider name is NetEnt
     * @param gameId
     * @returns {boolean}
     */
    const isNetEntGame = (gameId) => getProviderByGameId(gameId) === 'NetEnt';

    /**
     * Generates category hash.
     * @param categoryIndex
     * @returns {string}
     */
    const getCategoryKey = function (categoryIndex) {
        try {
            const catNameKey = categories.mainCategories[categoryIndex].name.replace(' ', '').toLowerCase();
            const subcatsHash = categories.mainCategories[categoryIndex]
                .subCategories.map((subCat) => subCat.name[0].toLowerCase()
                    + subCat.instantGamesOrder.length).join('');
            return `${catNameKey}-${subcatsHash}`;
        } catch {
            return null;
        }
    };

    /**
     * Generates sub-category hash.
     * @param categoryIndex
     * @param subCategoryIndex
     * @returns {`${string}-${string}-${string}`|null}
     */
    const getSubCategoryKey = function (categoryIndex, subCategoryIndex) {
        try {
            const catKey = getCategoryKey(categoryIndex);
            const subCatKey = categories.mainCategories[categoryIndex]
                .subCategories[subCategoryIndex].name.replace(' ', '').toLowerCase();
            const subCatGamesAmount = categories.mainCategories[categoryIndex]
                .subCategories[subCategoryIndex].instantGamesOrder.length;
            return `${catKey}-${subCatKey}-${subCatGamesAmount}`;
        } catch {
            return null;
        }
    };

    const getCurrentRecentGamesList = () => recentGames;

    const setRecentGamesToStore = () => {
        if (window.AsgSharedComponents) {
            const { setRecentGames } = AsgSharedComponents.getActionCreators();
            AsgSharedComponents.dispatch(setRecentGames(recentGames));
        }
    };

    const setGamesReadyToStore = async () => {
        if (window.AsgSharedComponents) {
            // put relevant arrays of game IDs into relevant subcategories
            const platformCategories = AsgFW.getCategories();
            const {
                fillPlatformCategories,
                handlePlatformGamesReady,
                fillGamesById,
            } = AsgSharedComponents.getActionCreators();

            await updateVerticalsInStore();

            AsgSharedComponents.dispatch(fillPlatformCategories(platformCategories));
            AsgSharedComponents.dispatch(fillGamesById(allGamesById));

            // set status
            AsgSharedComponents.dispatch(handlePlatformGamesReady(true));
        }
    };

    const getUpdatedVerticals = () => (new Promise((resolve, reject) => {
        // put relevant arrays of game IDs into relevant subcategories
        const platformCategories = AsgFW.getCategories();

        // get initial verticals containing virtual elements
        // to replace it with updated categories from platform
        const originalVerticals = AsgApp.getVerticals().byOrder.desktop;

        const {
            casino: { buyWin, prioritizedGames },
        } = AsgSharedComponents.getState();

        updateVerticalsObjectWorker.postMessage({
            verticals: originalVerticals,
            platformCategories,
            verticalTypesEnum: AsgApp.verticalTypesEnum,
            verticalActionTypesEnum: AsgApp.verticalActionTypesEnum,
            buyWinStoreData: buyWin,
            prioritizedGames,
            isMobile: AsgFW.isMobilePamPlatform(),
        });

        updateVerticalsObjectWorker.onmessage = (e) => {
            resolve(e.data.updatedVerticals);
        };

        updateVerticalsObjectWorker.onerror = () => {
            reject(new Error('updateVerticalsObjectWorker failed'));
        };
    }));

    const updateVerticalsInStore = async () => {
        const updatedVerticals = await getUpdatedVerticals();
        const { fillVerticals } = AsgSharedComponents.getActionCreators();

        AsgSharedComponents.dispatch(fillVerticals({
            byOrder: updatedVerticals,
        }));
    };

    const setBuyWinDataToStore = ({
        allBuyWinGamesIds,
        excludedSubProviders,
    }) => {
        if (window.AsgSharedComponents) {
            const {
                fillBuyWinGameIds,
                fillBuyWinExcludedSubProviders,
            } = AsgSharedComponents.getActionCreators();

            AsgSharedComponents.dispatch(fillBuyWinGameIds(allBuyWinGamesIds));
            AsgSharedComponents.dispatch(fillBuyWinExcludedSubProviders(excludedSubProviders));
        }
    };

    // Public interface.
    return {
        init,
        generateGameItem,
        isExclusiveGame,
        searchGameByName,
        getCategories,
        getCategoryGames,
        getCategoryName,
        getCategoryGamesWeb,
        getGameDetails,
        generateCategoryItem,
        generateSubCategoryItem,
        generateSubCategoryItemByCategory,
        getSubCategories,
        getDefaultCategory,
        getDefaultSubCategory,
        loadPartials,
        getGameByName,
        getGameById,
        getGameNameById,
        addRecentGamesSubCategories,
        addRecentGamesCategories,
        isNoDemoGame,
        getGameFlagStatus,
        isPresentPageGames,
        updateAllGames,
        processCmsGames,
        isGglBrandActive,
        setPreloadGames,
        sortGames,
        fetchRecentGames,
        recentGamesName,
        hideSortForRecents,
        getGameImageFromGameObject,
        liveCasinoStart,
        liveCasinoStop,
        liveCasinoRefresh,
        gameImprovementsRender,
        isNetEntGame,
        getCategoryKey,
        getSubCategoryKey,
        filterGamesByName,
        filterGamesByProvider,
        filterGamesBySubProvider,
        getFixedGamesList,
        getCurrentRecentGamesList,
        setRecentGamesToStore,
        updateVerticalsInStore,
    };
})();

/**
 * InGame
 *
 * */
const InGame = (function () {
    let CONTAINER_X_PADDING = 50;
    let CONTAINER_Y_PADDING = 50;
    let MAX_HEIGHT = 850;
    let MIN_HEIGHT = 476;
    let isInGameFlag;
    let gameMode = false;
    let currentGameId;
    let lastPlayedGameId;

    const setAttributes = function (xPadding, yPadding, minHeight, maxHeight) {
        CONTAINER_X_PADDING = xPadding || CONTAINER_X_PADDING;
        CONTAINER_Y_PADDING = yPadding || CONTAINER_Y_PADDING;
        MIN_HEIGHT = minHeight || MIN_HEIGHT;
        MAX_HEIGHT = maxHeight || MAX_HEIGHT;
    };

    const openInGame = function (gid, mode) {
        console.log('%cAsgApp:%c The game is to be opened -', 'background-color: #4cb848; color: #fff', 'color:#4cb848', gid, mode);
        Cookie.create(`isGamePlayed${mode}`, '1', '180');
        if (mode === 'R') {
            return;
        }
        const startGameEvent = new CustomEvent('startInGame', { detail: { gameId: gid, playMode: mode } });
        isInGameFlag = true;
        gameMode = mode;
        currentGameId = gid;
        setLastPlayedGameId(gid);

        // If old game page is used.
        if (!AsgApp.isEmbeddedGamePageEnabled(gid)) {
            document.dispatchEvent(startGameEvent);
            loadGameBackground(gid);
            setGameSize(gid);

            $('body').addClass('new-game-page-active');
        } else if (window.AsgSharedComponents) {
            // New embedded game page flow.
            const { currentGameId } = AsgSharedComponents.getState().casino.currentGame;
            const {
                loadEmbeddedGamePage,
                fillCurrentGameLoaded,
                fillGameSwitchInProgress,
            } = AsgSharedComponents.getActionCreators();

            if (!currentGameId || currentGameId !== gid) {
                AsgSharedComponents.dispatch(loadEmbeddedGamePage({
                    gameId: gid,
                }));
            }

            AsgSharedComponents.dispatch(fillCurrentGameLoaded(true));
            AsgSharedComponents.dispatch(fillGameSwitchInProgress(false));
            document.dispatchEvent(new Event('embeddedGameLoadStart'));
        }

        if (ExitGameMessage) {
            ExitGameMessage.hide();
            ExitGameMessage.isNeedToShow = true;
        }
    };

    const closeInGame = function (gameId, playMode) {
        Tools.log(`The game is to be closed - ${gameId}, ${playMode}`);
        const endGameEvent = new CustomEvent('endInGame', { detail: { gameId, playMode } });

        isInGameFlag = false;
        currentGameId = undefined;
        document.dispatchEvent(endGameEvent);

        $('.cover-screen').hide();
        if (!AsgApp.isGamePageTemplate()) {
            unloadGameBackground();
        }
        unbindResizeEvent();
        $('#ng-game-container').html('');
        Games.liveCasinoStart();

        // remove netent class after game was closed
        document.body.classList.remove('netent-game');

        if (!AsgApp.isFullScreenCurrently() && !isPassTroughGame()) {
            AsgApp.goOutFullscreen();
        }
        if (!isPassTroughGame()) {
            if (window.ExitGameMessage && !AsgApp.isGamePageTemplate()) {
                ExitGameMessage.show();
            }
            removeNewGamePageClass();
        }

        // close embedded game only in case event data fit to store
        // currentGameInStore is different from gameId when switching from old game page
        // to game page with header and game frame should not be closed
        if (window.AsgSharedComponents) {
            const {
                currentGame: { currentGameId: currentGameInStore },
            } = AsgSharedComponents.getState().casino;

            if (gameId === currentGameInStore) {
                closeEmbeddedGame();
            }
        }
    };

    const closeEmbeddedGame = () => {
        if (window.AsgSharedComponents) {
            const { gameSwitchInProgress } = AsgSharedComponents.getState()
                .casino
                .currentGame;

            // Don't close embedded game during switching to next game
            // (e.g. from Play Next or Search)
            if (!gameSwitchInProgress) {
                const { closeEmbeddedGame } = AsgSharedComponents.getActionCreators();
                AsgSharedComponents.dispatch(closeEmbeddedGame());

                AsgApp.goOutFullscreen();
            }
        }
    };

    const removeNewGamePageClass = () => {
        if (!AsgApp.isGamePageTemplate()) {
            $('body').removeClass('new-game-page-active');
        }
    };

    const isInGame = function () {
        return isInGameFlag;
    };

    const getCurrentGameId = function () {
        return currentGameId;
    };

    const getGameMode = function () {
        return gameMode;
    };

    const loadGameBackground = function (gid) {
        const url = Games.getGameDetails(gid).backgroundImageUrl;
        const img = new Image();
        img.onload = function () {
            setGameBackground(url);
        };
        img.onerror = function () {
            setGameBackground(`${AsgApp.getUniversalImagesUri()}defaultgamebg.jpg`);
        };
        img.src = url;
    };

    const setGameBackground = function (url) {
        $('.in-game-background').css('background-image', `url(${url})`).animate({ opacity: 1 }, 700);
    };

    const unloadGameBackground = function () {
        if (!isPassTroughGame()) {
            $('.in-game-background').css({ 'background-image': '', opacity: 0 });
        }
    };

    const setGameSize = function (gid) {
        const ratio = getGameRatio(gid);
        const boundaries = calculateBoundaries(ratio);

        function onResize() {
            const gameSize = calculateGameSize(boundaries);
            changeGameSize(gameSize);
        }

        onResize();
        $(window).on('resize.ingame', onResize);
    };

    const unbindResizeEvent = function () {
        $(window).off('resize.ingame');
    };

    const changeGameSize = function (size) {
        const localSize = size || $('.in-game-content-game').data('size');
        if (AsgFW.isMobilePamPlatform()) {
            const h = $(window).height() - 35;
            const w = $(window).width();

            $('.in-game-content-game').css({
                height: `${h}px`,
                width: `${w}px`,
                'margin-top': `${35}px`,
                'margin-left': `${0}px`,
            });

            if (localSize === '3') {
                $('.blog.is-mobile .wrap').attr('style', 'padding-top: 0px !important');
                $('.in-game-content-game').css({
                    position: 'fixed',
                    'margin-top': '15px',
                });
            }

            if (localSize === '4') {
                $('.in-game-content-game').css({
                    'margin-top': `${0}px`,
                });
            }
        } else {
            const topProp = !$('body').hasClass('game-page') ? 'padding' : 'margin';

            if (!AsgFW.isLoggedIn()) {
                // New Game page prelogin minimized mode.
                const gameAspectRatio = Games.getGameById(currentGameId).aspectRatio;
                const aspectHeight = 920 / gameAspectRatio;
                $('.in-game-content-game').css({
                    width: '920px',
                    height: `${aspectHeight}px`,
                    [`${topProp}-top`]: `${localSize.marginTop}px`,
                    'margin-left': `${localSize.marginLeft}px`,
                });
            } else {
                // Other desktops.
                $('.in-game-content-game').css({
                    height: `${localSize.height}px`,
                    width: `${localSize.width}px`,
                    [`${topProp}-top`]: `${localSize.marginTop}px`,
                    'margin-left': `${localSize.marginLeft}px`,
                });
            }
        }
    };

    const getGameRatio = function (gid) {
        return Games.getGameById(gid).aspectRatio;
    };

    const getAvailableSize = function () {
        // These classes does not exist in some brands
        const sidebarWidth = $('.in-game-side-left').width() + $('.in-game-side-right').width() || 0;
        const closeBtn = $('.in-game-close-button').width();

        const totalHeight = document.documentElement.clientHeight;
        const calculatedPadding = AsgFW.isMobilePamPlatform()
            ? CONTAINER_Y_PADDING
            : CONTAINER_Y_PADDING / 2;

        return {
            height: totalHeight - calculatedPadding,
            width: document.documentElement.clientWidth - 300,
        };
    };

    const calculateGameSize = function (boundaries) {
        let width;
        let height;
        const available = getAvailableSize();

        if (boundaries.MAX.HEIGHT > available.height || boundaries.MAX.WIDTH > available.width) {
            const resized = {
                width: Math.round(boundaries.MAX.WIDTH
                    * (available.height / boundaries.MAX.HEIGHT)),
                height: Math.round(boundaries.MAX.HEIGHT
                    * (available.width / boundaries.MAX.WIDTH)),
            };

            height = resized.height;
            width = available.width;

            if (resized.width <= available.width) {
                width = resized.width;
                height = available.height;

                // reduce height of panic button from game height
                if ($('body').hasClass('panic-button')) {
                    height -= 52;
                    if (isNewInGamePage()) {
                        height += 52;
                    }
                }
            }

            if (height < boundaries.MIN.HEIGHT || width < boundaries.MIN.WIDTH) {
                height = boundaries.MIN.HEIGHT;
                width = boundaries.MIN.WIDTH;
            }
        } else {
            width = boundaries.MAX.WIDTH;
            height = boundaries.MAX.HEIGHT;
        }

        const marginTop = CONTAINER_Y_PADDING / 2;
        const marginLeft = -1 * $('.in-game-side-right').width();
        const marginRight = -1 * $('.in-game-side-left').width();

        return {
            width,
            height,
            marginTop,
            marginLeft,
            marginRight,
        };
    };

    const calculateBoundaries = function (ratio) {
        return {
            MAX: {
                WIDTH: MAX_HEIGHT * ratio,
                HEIGHT: MAX_HEIGHT,
            },
            MIN: {
                WIDTH: MIN_HEIGHT * ratio,
                HEIGHT: MIN_HEIGHT,
            },
        };
    };

    const setNewGamePagePreferences = () => {
        MAX_HEIGHT = 937;
        MIN_HEIGHT = 400;
        CONTAINER_Y_PADDING = 0;

        if (!AsgApp.isGamePageTemplate()) {
            setNewInGamePagePreferences();
        }

        $('.game-page.new-game-page .full-screen-icon, .new-in-game-content-container .full-screen-icon-holder').on('click', function () {
            newGamePageFullScreenHandler();
        });

        $(window).on('scroll', function () {
            if ($(this).scrollTop() === 0) {
                $('.game-page.new-game-page .in-game-header').removeClass('scrolled');
                $('.game-page.new-game-page .in-game-header .full-screen-icon').css('display', 'flex');
            } else {
                $('.game-page.new-game-page .in-game-header').addClass('scrolled');
                $('.game-page.new-game-page .in-game-header .full-screen-icon').css('display', 'none');
            }
        });
        document.addEventListener('keydown', function (e) {
            if ($('body').hasClass('new-game-page-active')) {
                const KeyCode = e.key;
                if (KeyCode === 'F11') {
                    newGamePageFullScreenHandler();
                }
            }
        });

        // handle status bar DOM in case of full screen exit from external code
        document.addEventListener('fullscreenchange', () => {
            if (AsgApp.isFullScreenCurrently()) {
                handleStatusBarDomFullScreenExit();
            }
        });
    };

    const setNewInGamePagePreferences = () => {
        CONTAINER_Y_PADDING = 28;

        if (AsgFW.isMobilePamPlatform()) {
            $(document).on('gamesReady', function () {
                AsgApp.exitGameMessageCheck();
            });
        }

        if (!AsgFW.isMobilePamPlatform() && AsgApp.isShowWalkThrough()) {
            AsgApp.openWalkThroughSkip();
        }

        const homeButtonEl = document.querySelector('.home-button-btn');
        const homeContainerEl = document.querySelector('.back-to-home-confirm-container');
        $('#in-game-container').on('click', (event) => {
            if (homeButtonEl && !homeButtonEl.contains(event.target) && $(homeButtonEl).css('display') === 'flex' && !homeContainerEl.contains(event.target)) {
                $('.back-to-home-confirm-container').hide();
            }
        });

        $('.new-in-game-content-container .home-button-btn').on('click', function () {
            $('.back-to-home-confirm-container').animate({
                opacity: 'toggle',
            }, function () {
                if ($(this).is(':visible')) {
                    $(this).css('display', 'flex');
                }
            });
        });

        $('.back-to-home-confirm-button').on('click', function () {
            $('.back-to-home-confirm-container').animate({
                opacity: 'toggle',
            });
        });

        $('.cta-common:not(.home-button-btn), .back-to-home-confirm-button').on('click', function () {
            if (!AsgApp.isFullScreenCurrently()) {
                AsgApp.goOutFullscreen();
            }
        });
    };

    const handleStatusBarDomFullScreenExit = () => {
        $('.new-in-game-content-container #status-bar').prop('id', 'full-screen-status-bar');
        $('#inactive-status-bar').prop('id', 'status-bar');
        AsgUI.renderStatusBar();
    };

    const newGamePageFullScreenHandler = () => {
        const fullScreenElement = 'in-game-content-container';

        if (AsgApp.isFullScreenCurrently()) {
            AsgApp.goInFullscreenById(fullScreenElement);
            $('#status-bar').prop('id', 'inactive-status-bar');
            $('.new-in-game-content-container #full-screen-status-bar').prop('id', 'status-bar');
            AsgUI.renderStatusBar();
        } else {
            handleStatusBarDomFullScreenExit();
            AsgApp.goOutFullscreen();
        }
    };

    const isNewInGamePage = () => !AsgFW.isMobilePamPlatform();

    const isPassTroughGame = () => $('body').hasClass('pass-trough-game');

    const setLastPlayedGameId = (gid) => {
        lastPlayedGameId = parseInt(gid, 10);
    };

    const getLastPlayedGameId = () => lastPlayedGameId;

    $(document).on('LoggedOut endInGame', function () {
        gameMode = false;
    });

    // Add special Mobile NetEnt games header behavior.
    $(document).on('startInGame endInGame', function (event) {
        if (AsgFW.isMobilePamPlatform() && Games.getGameById(event.detail.gameId).externalGameProvider === 'NetEnt') {
            if (event.type === 'startInGame') {
                $('#in-game-container .extra-mobile-game-header').addClass('netent show');
            } else {
                $('#in-game-container .extra-mobile-game-header').removeClass('netent show');
            }
        }
    });

    return {
        setNewGamePagePreferences,
        openInGame,
        closeInGame,
        isInGame,
        getCurrentGameId,
        setAttributes,
        getGameMode,
        isPassTroughGame,
        setLastPlayedGameId,
        getLastPlayedGameId,
    };
})();

/**
 * Phonegap
 *
 * */
const Phonegap = (function () {
    let PhonegapData;

    const init = function (data) {
        PhonegapData = data;
    };

    const getPhonegapData = function () {
        return PhonegapData;
    };

    const fireAppsflyerEvent = function (eventName) {
        // ajax to appsflyer
        $.ajax({
            type: 'POST',
            // TODO: check if this still relevant for any Apps
            url: 'https://fnc.aspireglobal.com/phoneGap/apis/curl.php',
            data: {
                type: 'fireAppsflyerEvent',
                eventName,
                param: PhonegapData,
            },
            success(data) {
                console.log(data);
            },
            dataType: 'json',
        });
    };

    return {
        init,
        getPhonegapData,
        fireAppsflyerEvent,
    };
})();

/*** EXPORTS FROM exports-loader ***/
export {
  AsgApp,
  Player,
  Games,
  InGame,
  Phonegap
};
